import { en } from './en';
import type { Dict } from '../types';

export const pl: Dict = {
  ...en,
  'plugins.actions.copyInstallCommand': 'Kopiuj polecenie instalacji',
  'plugins.actions.copyPluginId': 'Kopiuj ID wtyczki',
  'plugins.actions.copyReadmeBadge': 'Kopiuj odznakę README',
  'plugins.actions.openSourceGithub': 'Otwórz źródło na GitHubie',
  'plugins.actions.openSource': 'Otwórz źródło',
  'plugins.actions.openHomepage': 'Otwórz stronę domową',
  'plugins.actions.openMarketplace': 'Otwórz w marketplace',
  'workingDirPicker.title': "Folder",
  'workingDirPicker.homeTitle': "Choose where this project should live",
  'workingDirPicker.processing': "Processing…",
  'workingDirPicker.select': "Choose working directory",
  'workingDirPicker.clearAria': "Clear working directory",
  'workingDirPicker.replaceFailed': "Could not replace working directory",
  'workingDirPicker.unavailable': "Folder picker is unavailable in this build. Run the desktop app to pick a folder.",
  'workingDirPicker.openUnavailable': "Open this project in the desktop app to show the folder.",
  'workingDirPicker.openFailed': "Could not show this folder",
  'workingDirPicker.showInFileManager': "Show in file manager",
  'workingDirPicker.replace': "Clear and replace directory…",
  'workingDirPicker.recent': "Recent directories",
  'handoff.toTarget': 'Hand off to {target}',
  'handoff.action': 'Hand off',
  'handoff.fallbackTitle': 'No editors found on $PATH - opens in {target}',
  'handoff.chooseTargetAria': 'Choose hand-off target',
  'handoff.notInstalled': 'Not installed',
  'handoff.notDetectedTitle': '{target} - not detected on $PATH',
  'homeHero.promptExamples': "Przykłady",
  'homeHero.footer.designSystem': "Styl",
  'homeHero.footer.autoDesignSystem': "Auto",
  'homeHero.footer.autoDesignSystemSummary': "Automatycznie dobiera najlepszy system projektowy i styl wizualny do bieżącego promptu.",
  'homeHero.footer.ratio': "Proporcje",
  'homeHero.footer.duration': "Czas",
  'homeHero.footer.resolution': "Rozdzielczość",
  'homeHero.footer.speakerNotes': "Notes",
  'homeHero.footer.noSpeakerNotes': "Bez notatek",
  'homeHero.footer.availableCount': "{n} available",
  'homeHero.footer.noMatches': "No matches",
  'homeHero.moreShortcuts': "Więcej",
  'common.cancel': 'Anuluj',
  'common.save': 'Zapisz',
  'common.close': 'Zamknij',
  'common.delete': 'Usuń',
  'common.rename': 'Zmień nazwę',
  'common.edit': 'Edytuj',
  'common.preview': 'Podgląd',
  'common.share': 'Udostępnij',
  'common.search': 'Szukaj',
  'common.searchEllipsis': 'Szukaj…',
  'common.loading': 'Ładowanie…',
  'common.all': 'Wszystkie',
  'common.none': 'Brak',
  'common.default': 'Domyślne',
  'common.installed': 'zainstalowano',
  'common.notInstalled': 'nie zainstalowano',
  'common.active': 'aktywny',
  'common.offline': 'offline',
  'common.selected': 'wybrano',
  'common.create': 'Utwórz',
  'common.openPreview': 'Otwórz podgląd',
  'common.exitFullscreen': 'Zamknij pełny ekran',
  'common.fullscreen': 'Pełny ekran',
  'common.openInNewTab': 'Otwórz w nowej karcie',
  'common.exportPdf': 'Eksportuj jako PDF',
  'common.exportZip': 'Pobierz jako .zip',
  'common.exportHtml': 'Eksportuj jako samodzielny HTML',
  'common.justNow': 'przed chwilą',
  'common.minutesAgo': '{n} min temu',
  'common.hoursAgo': '{n} godz. temu',
  'common.daysAgo': '{n} dni temu',
  'common.weeksAgo': '{n}w ago',
  'common.now': 'teraz',
  'common.minutesShort': '{n}m',
  'common.hoursShort': '{n}h',
  'common.daysShort': '{n}d',
  'common.untitled': 'Bez tytułu',

  'app.brand': 'Open Design',
  'app.brandPill': 'Wersja badawcza',
  'app.brandSubtitle': 'od Nexu Labs',
  'app.welcomeLoading': 'Ładowanie obszaru roboczego…',

  'settings.welcomeKicker': "",
  'settings.welcomeTitle': "Welcome",
  'settings.welcomeSubtitle': "",
  'settings.onboardingCreateTitle': 'Start from a brief',
  'settings.onboardingCreateBody':
    'Describe the site, app, deck, image, or video you want. Open Design will create a project and keep the work editable.',
  'settings.onboardingMemoryTitle': 'Save working context',
  'settings.onboardingMemoryBody':
    'Add preferences, project facts, and recurring rules so future chats pick up the right context.',
  'settings.onboardingSystemsTitle': 'Bring your design system',
  'settings.onboardingSystemsBody':
    'Pick or create a brand system so generated work follows real colors, typography, and product language.',
  'settings.onboardingExecutionTitle': 'Choose how generation runs',
  'settings.onboardingExecutionBody':
    'Use a local CLI agent or connect your own API key. You can change this any time in Settings.',
  'settings.onboardingStepConnect': "Connect",
  'settings.onboardingStepDesignSystem': "Design system",
  'settings.onboardingStepProfile': "About you",
  'settings.onboardingConnectTitle': "Choose a runtime",
  'settings.onboardingConnectBody': "",
  'settings.onboardingRecommended': "Recommended",
  'settings.onboardingLocalTitle': "Local coding agent",
  'settings.onboardingLocalBody': "Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.",
  'settings.onboardingLocalAction': "Open CLI settings",
  'settings.onboardingCliScanHint': "This usually takes 5-10 seconds.",
  'settings.onboardingByokTitle': "Bring your own key",
  'settings.onboardingByokBody': "Use your own model provider credentials.",
  'settings.onboardingByokAction': "Open BYOK settings",
  'settings.onboardingDesignTitle': "Design system",
  'settings.onboardingDesignBody': "Generate once, reuse everywhere.",
  'settings.onboardingDesignIntroGenerateTitle': "Generate from existing work",
  'settings.onboardingDesignIntroGenerateBody': "Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.",
  'settings.onboardingDesignIntroReuseTitle': "Reuse in future work",
  'settings.onboardingDesignIntroReuseBody': "Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.",
  'settings.onboardingDesignIntroSkipTitle': "Optional for now",
  'settings.onboardingDesignIntroSkipBody': "Skip this step if you want to start without generating a design system.",
  'settings.onboardingGithubTitle': "Import from GitHub",
  'settings.onboardingGithubBody': "Use a frontend repository.",
  'settings.onboardingUploadTitle': "Upload local files",
  'settings.onboardingUploadBody': "Add project files, screenshots, CSS, docs, or assets.",
  'settings.onboardingPromptTitle': "Generate from prompt",
  'settings.onboardingPromptBody': "Describe the product or brand.",
  'settings.onboardingProfileTitle': "About you",
  'settings.onboardingProfileBody': "Optional details for better defaults.",
  'settings.onboardingRoleLabel': "Your role",
  'settings.onboardingOrgSizeLabel': "Organization size",
  'settings.onboardingUseCaseLabel': "Use case",
  'settings.onboardingSourceLabel': "Where did you hear about us?",
  'settings.onboardingSelectPlaceholder': "Select one",
  'settings.onboardingSelectMultiplePlaceholder': "Select one or more",
  'settings.onboardingOrgSolo': "Solo / personal (1)",
  'settings.onboardingOrgTeam': "Small team (2-10)",
  'settings.onboardingOrgStartup': "Startup / SMB (11-50)",
  'settings.onboardingOrgGrowth': "Growth company (51-200)",
  'settings.onboardingOrgMidMarket': "Mid-market (201-1000)",
  'settings.onboardingOrgEnterprise': "Enterprise (1000+)",
  'settings.onboardingRolePm': "📋 Product manager",
  'settings.onboardingRoleDesigner': "🎨 Designer",
  'settings.onboardingRoleEngineer': "💻 Engineer",
  'settings.onboardingRoleMarketing': "📣 Marketing",
  'settings.onboardingRoleGrowth': "📈 Growth",
  'settings.onboardingRoleOps': "⚙️ Operations",
  'settings.onboardingRoleFounder': "🚀 Founder / executive",
  'settings.onboardingRoleStudent': "🎓 Student / educator",
  'settings.onboardingRoleOther': "✨ Other",
  'settings.onboardingUseProduct': "🎨 Product design",
  'settings.onboardingUseDesignSystem': "🧩 Design system",
  'settings.onboardingUsePrototype': "📱 Prototype / app UI",
  'settings.onboardingUseLanding': "🌐 Landing pages",
  'settings.onboardingUseAds': "📣 Ads / social content",
  'settings.onboardingUseDashboard': "📊 Dashboards / internal tools",
  'settings.onboardingUseDeck': "🖥️ Presentation / deck",
  'settings.onboardingUseMarketing': "📈 Marketing / growth",
  'settings.onboardingUseEngineering': "🤝 Engineering handoff",
  'settings.onboardingUseAgency': "💼 Agency / client work",
  'settings.onboardingSourceGithub': "🐙 GitHub",
  'settings.onboardingSourceFriend': "👥 Friend or coworker",
  'settings.onboardingSourceSocial': "📱 Social media",
  'settings.onboardingSourceProductHunt': "🅿️ Product Hunt",
  'settings.onboardingSourceCommunity': "💬 Design / AI community",
  'settings.onboardingSourceYoutube': "▶️ YouTube",
  'settings.onboardingSourceBlog': "📰 Blog or newsletter",
  'settings.onboardingSourceAiTool': "✨ AI tool recommendation",
  'settings.onboardingSourceSearch': "🔍 Search",
  'settings.onboardingSourceEvent': "🎤 Event or community",
  'settings.onboardingBack': "Back",
  'settings.onboardingContinue': "Continue",
  'settings.onboardingFinish': "Finish setup",
  'settings.onboardingSkip': "Skip for now",
  'settings.kicker': 'Ustawienia',
  'settings.title': 'Tryb wykonywania',
  'settings.subtitle': 'Wybierz lokalne CLI albo BYOK.',
  'settings.modeAria': 'Tryb wykonywania',
  'settings.protocolAria': 'Protokół API',
  'settings.modeDaemon': 'Lokalne CLI',
  'settings.modeDaemonHelp': 'Uruchamiaj przez agenta CLI na swoim komputerze',
  'settings.modeDaemonOffline': 'Daemon nie jest uruchomiony',
  'settings.modeDaemonOfflineMeta': 'daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} zainstalowano',
  'settings.modeApi': 'Dostawca API',
  'settings.modeApiMeta': 'BYOK',
  'settings.codeAgent': 'Agent kodu',
  'settings.codeAgentHint':
      'Wykryto poprzez skanowanie PATH. Wybierz CLI, przez które mają przechodzić generacje.',
  'settings.rescan': '↻ Ponów skanowanie',
  'settings.rescanTitle': 'Ponownie skanuj PATH',
  'settings.rescanRunning': 'Skanowanie...',
  'settings.rescanSuccess': 'Skanowanie zakończone. Dostępne: {count}.',
  'settings.designSystemRenameFailed': 'Zmiana nazwy nie powiodła się. Sprawdź daemon i spróbuj ponownie.',
  'settings.rescanFailed': 'Skanowanie nie powiodło się. Sprawdź daemon i spróbuj ponownie.',
  'settings.test': 'Test',
  'settings.testTitle': 'Wyślij maleńki monit testowy, aby zweryfikować połączenie',
  'settings.testRunning': 'Testowanie połączenia…',
  'settings.testCancel': 'Anuluj',
  'settings.testSuccessApi': 'Połączono. Odpowiedź w {ms} ms — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} odpowiedział w {ms} ms — \'{sample}\'',
  'settings.testAuthFailed': 'Uwierzytelnianie nie powiodło się. Sprawdź klucz API.',
  'settings.testForbidden': 'Brak dostępu. Sprawdź konto, region lub organizację.',
  'settings.testNotFoundModel': 'Nie znaleziono modelu \'{model}\' w tym punkcie końcowym.',
  'settings.testInvalidModelId': 'Id modelu \'{model}\' jest nieprawidłowy. Własne id musi zaczynać się od litery lub cyfry i nie może zawierać spacji.',
  'settings.testInvalidBaseUrl': 'Base URL jest nieprawidłowy lub nieosiągalny.',
  'settings.testRateLimited': 'Dostawca ograniczył test. Konfiguracja wygląda poprawnie.',
  'settings.testUpstream': 'Dostawca zwrócił {status}. Spróbuj ponownie za chwilę.',
  'settings.testTimeout': 'Test przekroczył limit czasu po {ms} ms.',
  'settings.testAgentMissing': '{agentName} nie jest zainstalowany lub nie jest w PATH.',
  'settings.testAgentSpawn': 'Nie można uruchomić {agentName}: {detail}.',
  'settings.testUnknown': 'Test nieudany: {detail}',
  'settings.agentInstall.install': 'Zainstaluj',
  'settings.agentInstall.docs': 'Dokumentacja',
  'settings.agentInstall.pathHint':
    'Jeśli zainstalowano CLI przez npm lub Homebrew, ale nadal widnieje jako niezainstalowana, upewnij się, że katalog bin narzędzia jest w PATH dziedziczonym przez daemon Open Design (na macOS PATH w Terminalu i aplikacjach GUI może się różnić). Zobacz QUICKSTART.md (sekcja "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Otwórz Zainstaluj lub Dokumentacja dla wybranego agenta.',
  'settings.agentInstall.stepAuth':
    'Uwierzytelnij się w CLI dostawcy (zaloguj się lub dodaj dane API), zanim wrócisz do Open Design.',
  'settings.agentInstall.stepRescan': 'Kliknij Ponów skanowanie w tej sekcji.',
  'settings.agentInstall.stepSelect': 'Wybierz kartę agenta, gdy pojawi się jako zainstalowany.',
  'settings.noAgentsDetected':
      'Nie wykryto jeszcze żadnych agentów. Zainstaluj Claude Code, Codex, Devin for Terminal, Gemini CLI, OpenCode, Cursor Agent, Qwen lub GitHub Copilot CLI, a następnie kliknij Ponów skanowanie.',
  'settings.agentInstalledGroup': 'Twoje CLI ({count})',
  'settings.agentInstallGroup': 'Dostępne do instalacji ({count})',
  'settings.agentAuthRequired': 'Wymagane uwierzytelnienie',
  'settings.agentAuthUnknown': 'Stan uwierzytelnienia nieznany',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Szybkie wypełnienie dostawcy',
  'settings.customProvider': 'Niestandardowy dostawca',
  'settings.apiKey': 'Klucz API',
  'settings.showKey': 'Pokaż klucz',
  'settings.hideKey': 'Ukryj klucz',
  'settings.show': 'Pokaż',
  'settings.hide': 'Ukryj',
  'settings.model': 'Model',
  'settings.suggestedModelsHint':
      'To sugerowane modele dla tego protokołu. Twój dostawca może obsługiwać inne modele.',
  'settings.baseUrl': 'Bazowy URL',
  'settings.baseUrlInvalid': 'Wpisz poprawny publiczny URL http:// lub https://. Localhost jest dozwolony; prywatne adresy IP są blokowane.',
  'settings.baseUrlCustomize': 'Dostosuj',
  'settings.baseUrlDefaultHint': 'Domyślny punkt końcowy. Zwykle nie trzeba go zmieniać.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Find this in Azure portal → your resource → Endpoint.',
  'settings.azureDeploymentModel': 'Nazwa wdrożenia',
  'settings.azureDeploymentModelHint':
      'Dla Azure OpenAI to pole jest używane jako nazwa wdrożenia w /openai/deployments/<model>. Wpisz nazwę wdrożenia utworzonego w Azure.',
  'settings.apiVersion': 'Wersja API',
  'settings.byokImageModel': 'Model generowania obrazów',
  'settings.maxTokens': 'Maks. liczba tokenów (opcjonalnie)',
  'settings.maxTokensHint':
      'Limit długości odpowiedzi. Każdy model ma dostrojony domyślny limit (widoczny jako placeholder); pozostaw puste, aby go użyć, lub wpisz liczbę.',
  'settings.apiHint': 'Wywołania są wysyłane przez lokalny proxy daemon do ustawionego Base URL. Klucz jest przechowywany tylko w tej przeglądarce i wysyłany z żądaniami do dostawcy.',
  'settings.skipForNow': 'Pomiń na razie',
  'settings.getStarted': 'Rozpocznij',
  'settings.envConfigure': 'Tryb wykonywania',
  'settings.localCli': 'Lokalne CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'nie wybrano agenta',
  'settings.language': 'Język',
  'settings.languageHint': 'Zmień język interfejsu. Zapisano w tej przeglądarce.',
  'settings.appearance': 'Wygląd',
  'settings.appearanceHint': 'Jasny, ciemny lub zgodny z ustawieniami systemu.',
  'settings.themeSystem': 'Systemowy',
  'settings.themeLight': 'Jasny',
  'settings.themeDark': 'Ciemny',
  'settings.agentModelHead': 'Model dla:',
  'settings.modelPicker': 'Model',
  'settings.modelSourceLive': 'Na żywo z CLI',
  'settings.modelSourceFallback': 'Lista wbudowana',
  'settings.reasoningPicker': 'Poziom rozumowania',
  'settings.modelPickerHint':
      'Pobierane z CLI, gdy obsługuje ono polecenie `models`. „Domyślne” pozostawia wybór konfiguracji CLI; „Własne…” pozwala wpisać dowolne ID modelu akceptowane przez CLI.',
  'settings.modelPickerLiveHint':
    'Modele zostały odświeżone z zainstalowanego CLI. Domyślny wybór nadal używa konfiguracji CLI.',
  'settings.modelPickerFallbackHint':
    'Wyświetlane są wbudowane wartości domyślne. Kliknij Ponów skanowanie, aby pobrać modele na żywo z CLI.',
  'settings.cliEnvTitle': 'CLI config locations',
  'settings.cliEnvHint':
    'Set non-secret config directories for packaged app runs and agent detection.',
  'settings.cliEnvClaudeConfigDir': 'Claude Code config directory',
  'settings.cliEnvClaudeBaseUrl': 'Claude proxy base URL',
  'settings.cliEnvClaudeApiKey': 'Claude proxy API key',
  'settings.cliEnvCodexHome': 'Codex home',
  'settings.cliEnvCodexBin': 'Codex executable path',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI proxy base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI proxy API key',
  'settings.modelCustom': 'Własny (wpisz poniżej)…',
  'settings.modelCustomLabel': 'Własne ID modelu',
  'settings.modelCustomPlaceholder': 'np. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Dostawcy multimediów',
  'settings.mediaProvidersHint':
      'Klucze API do generowania obrazów, wideo i dźwięku. Przechowywane lokalnie i synchronizowane z lokalnym daemonem.',
  'settings.mcpServerTitle': 'Serwer MCP',
  'settings.mcpServerHint': 'Udostępnij Open Design jako serwer MCP dla swojego agenta kodu.',
  'settings.externalMcpTitle': 'Zewnętrzny MCP',
  'settings.externalMcpHint': 'Dodaj narzędzia MCP z usług zewnętrznych (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'Klucz API',
  'settings.mediaProviderBaseUrl': 'Bazowy URL',
  'settings.mediaProviderConfigured': 'Skonfigurowano',
  'settings.mediaProviderUnset': 'Nieustawione',
  'settings.mediaProviderClear': 'Wyczyść',
  'settings.mediaProviderClearConfirm': 'Usunąć zapisane ustawienia dla {name}? Aby ponownie używać {name}, musisz wprowadzić je ponownie.',
  'settings.mediaProviderPlaceholder': 'Wklej klucz API',
  'settings.mediaProviderBaseUrlPlaceholder': 'Nadpisz domyślny bazowy URL',
  'settings.mediaProviderReload': 'Przeładuj z lokalnego daemona',
  'settings.mediaProviderReloadError': 'Nie udało się ponownie wczytać ustawień dostawców mediów z lokalnego demona.',
  'settings.mediaProviderReloadSuccess': 'Ustawienia dostawców mediów zostały ponownie wczytane z lokalnego demona.',
  'settings.mediaProviderLoadError': 'Nie udało się wczytać ustawień dostawców mediów z lokalnego demona. Na razie używane będą ustawienia zapisane w przeglądarce.',
  'settings.mediaProviderComingSoonHint': 'Śledzimy je w mapie drogowej; daemon nie dostarcza jeszcze klienta, więc nie ma nic do skonfigurowania.',
  'settings.privacy': 'Privacy',
  'settings.privacyHint': 'What data is shared with the Open Design team',
  'settings.privacyConsentKicker': 'Help us improve Open Design',
  'settings.privacyConsentLead': 'Open Design can share usage data with our team to help us improve. This includes:',
  'settings.privacyConsentFooter': 'You can change either of these any time in Settings → Privacy. We never upload the contents of your generated artifact files.',
  'settings.privacyConsentShare': 'Share usage data',
  'settings.privacyConsentDecline': "Don't share",
  'settings.privacyConsentAccept': 'I get it',
  'settings.privacyConsentBannerFooter':
    'Data sharing is on by default. You can turn it off any time in Settings → Privacy. We never upload the contents of your generated artifact files.',
  'settings.privacyConsentPolicyLink': 'Read the privacy policy',
  'settings.privacyMetrics': 'Anonymous metrics',
  'settings.privacyMetricsHint': 'Run counts, token usage, error rate, duration. No prompts, no project data.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': "Your prompts and the assistant's responses (truncated 8 KB / 16 KB). API keys, tokens, JWTs, emails, IPs, and credit-card numbers are stripped automatically before send.",
  'settings.privacyArtifacts': 'Project artifacts manifest',
  'settings.privacyArtifactsHint': 'Filenames, types, sizes of generated files. File contents are never sent.',
  'settings.privacyInstallationId': 'Anonymous ID',
  'settings.privacyOptedOut': 'opted out',
  'settings.privacyDataDeletion': 'Delete my data',
  'settings.privacyDataDeletionHint': 'Rotates your anonymous ID and stops sending. Existing traces age out under our retention policy.',
  'settings.about': 'O aplikacji',
  'settings.aboutHint': 'Szczegóły wersji i środowiska uruchomieniowego',
  'settings.appVersion': 'Wersja',
  'settings.appChannel': 'Kanał',
  'settings.appRuntime': 'Środowisko',
  'settings.appPlatform': 'Platforma',
  'settings.appArchitecture': 'Architektura',
  'settings.runtimePackaged': 'Aplikacja spakowana',
  'settings.runtimeDevelopment': 'Rozwojowe',
  'settings.versionUnavailable': 'Szczegóły wersji są niedostępne, gdy daemon jest offline.',
  'settings.installLatest': 'Zainstaluj najnowszą wersję',
  'settings.alreadyLatest': 'Masz już najnowszą wersję',

  'entry.tabDesigns': 'Projekty',
  'entry.tabTemplates': 'Szablony',
  'entry.tabDesignSystems': 'Systemy projektowania',
  'entry.tabConnectors': 'Konektory',
  'entry.openSettingsTitle': 'Ustawienia',
  'entry.openSettingsAria': 'Otwórz ustawienia',
  'entry.resizeAria': 'Zmień rozmiar paska bocznego',
  'entry.loadingWorkspace': 'Ładowanie obszaru roboczego…',
  'entry.useEverywhereTitle': 'Używaj wszędzie',
  'entry.useEverywhereAria': 'Otwórz przewodnik „Używaj wszędzie” (CLI, MCP, HTTP, Skills)',
  'entry.navNewProject': 'Nowy projekt',
  'entry.navHome': 'Strona główna',
  'entry.navProjects': 'Projekty',
  'entry.navDesignSystems': 'Systemy projektowe',
  'entry.helpAria': 'Pomoc',
  'entry.helpMenuAria': 'Menu pomocy',
  'entry.helpGetHelp': 'Uzyskaj pomoc na GitHubie',
  'entry.helpSubmitFeature': 'Zaproponuj funkcję',
  'entry.helpWhatsNew': 'Co nowego',
  'entry.helpDownloadDesktop': 'Pobierz aplikację na komputer',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': 'Daj nam gwiazdkę na GitHubie',
  'entry.githubStarAria': 'Daj Open Design gwiazdkę na GitHubie',
  'entry.tabImageTemplates': 'Szablony obrazów',
  'entry.tabVideoTemplates': 'Szablony wideo',
  'promptTemplates.searchPlaceholder': 'Szukaj szablonów…',
  'promptTemplates.countLabel': '{n} wyników',
  'promptTemplates.emptyImage': 'Nie zainstalowano jeszcze szablonów promptów obrazów.',
  'promptTemplates.emptyVideo': 'Nie zainstalowano jeszcze szablonów promptów wideo.',
  'promptTemplates.emptyNoMatch': 'Brak szablonów pasujących do wyszukiwania.',
  'promptTemplates.attributionFooter': 'Zaadaptowano z publicznych bibliotek promptów. Każda karta linkuje do oryginalnego autora.',
  'promptTemplates.openPreviewTitle': 'Otwórz prompt i podgląd',
  'promptTemplates.sourcePrefix': 'Źródło:',
  'promptTemplates.fetchError': 'Nie udało się załadować treści szablonu.',
  'promptTemplates.promptLabel': 'Treść promptu',
  'promptTemplates.copyPrompt': 'Kopiuj prompt',
  'promptTemplates.copyDone': 'Skopiowano!',
  'promptTemplates.modelHint': 'Sugerowany model: {model}',
  'promptTemplates.openSource': 'Zobacz oryginał',
  'promptTemplates.openFullscreen': 'Podgląd pełnoekranowy',
  'promptTemplates.closeFullscreen': 'Zamknij podgląd pełnoekranowy',
  'promptTemplates.allSources': 'Wszystkie źródła',
  'promptTemplates.sourceFilterAria': 'Filtruj według źródła',
  'promptTemplates.retry': 'Ponów',

  'connectors.title': 'Konektory',
  'connectors.subtitle': 'Lokalne i przyszłe źródła danych, które mogą zasilać artefakty live.',
  'connectors.account': 'Konto',
  'connectors.noAccount': 'Niepołączone',
  'connectors.tools': 'Narzędzia',
  'connectors.connect': 'Połącz',
  'connectors.disconnect': 'Rozłącz',
  'connectors.authorizationPending': 'Oczekiwanie na autoryzację...',
  'connectors.authorizationPendingHint': 'Dokończ autoryzację w otwartym oknie.',
  'connectors.cancelAuthorization': 'Anuluj',
  'connectors.configure': 'Skonfiguruj',
  'connectors.unavailable': 'Niedostępne',
  'connectors.phaseStubTitle': 'Interfejsy konektorów pojawią się w fazie 3; to tylko podgląd.',
  'connectors.statusAvailable': 'Dostępne',
  'connectors.statusConnected': 'Połączone',
  'connectors.statusError': 'Błąd',
  'connectors.statusDisabled': 'Wyłączone',
  'connectors.gateTitle': 'Dodaj klucz API Composio, aby kontynuować',
  'connectors.gateBody': 'Wklej klucz powyżej i kliknij Zapisz klucz, aby wczytać dostępne integracje.',
  'connectors.aboutLabel': 'Informacje',
  'connectors.detailsLabel': 'Szczegóły',
  'connectors.statusLabel': 'Status',
  'connectors.category.aiAgents': 'Agenci AI',
  'connectors.category.aiInfrastructure': 'Infrastruktura AI',
  'connectors.category.accounting': 'Księgowość',
  'connectors.category.admin': 'Administracja',
  'connectors.category.advertising': 'Reklama',
  'connectors.category.analytics': 'Analityka',
  'connectors.category.automation': 'Automatyzacja',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Kalendarz',
  'connectors.category.commerce': 'Handel',
  'connectors.category.communication': 'Komunikacja',
  'connectors.category.contacts': 'Kontakty',
  'connectors.category.dataPlatform': 'Platforma danych',
  'connectors.category.database': 'Baza danych',
  'connectors.category.design': 'Design',
  'connectors.category.developer': 'Narzędzia deweloperskie',
  'connectors.category.documentation': 'Dokumentacja',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Edukacja',
  'connectors.category.email': 'E-mail',
  'connectors.category.events': 'Wydarzenia',
  'connectors.category.fieldService': 'Serwis terenowy',
  'connectors.category.finance': 'Finanse',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Formularze',
  'connectors.category.gaming': 'Gry',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Hotelarstwo',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integracja',
  'connectors.category.localization': 'Lokalizacja',
  'connectors.category.logistics': 'Logistyka',
  'connectors.category.maps': 'Mapy',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Media',
  'connectors.category.meetings': 'Spotkania',
  'connectors.category.nonprofit': 'Nonprofit',
  'connectors.category.observability': 'Obserwowalność',
  'connectors.category.payments': 'Płatności',
  'connectors.category.personal': 'Osobiste',
  'connectors.category.presentations': 'Prezentacje',
  'connectors.category.procurement': 'Zakupy',
  'connectors.category.product': 'Produkt',
  'connectors.category.productivity': 'Produktywność',
  'connectors.category.projectManagement': 'Zarządzanie projektami',
  'connectors.category.recruiting': 'Rekrutacja',
  'connectors.category.research': 'Badania',
  'connectors.category.salesIntelligence': 'Analiza sprzedaży',
  'connectors.category.scheduling': 'Planowanie',
  'connectors.category.search': 'Wyszukiwanie',
  'connectors.category.security': 'Bezpieczeństwo',
  'connectors.category.signing': 'Podpisywanie',
  'connectors.category.social': 'Social',
  'connectors.category.spreadsheets': 'Arkusze kalkulacyjne',
  'connectors.category.storage': 'Pamięć',
  'connectors.category.support': 'Wsparcie',
  'connectors.category.surveys': 'Ankiety',
  'connectors.category.tasks': 'Zadania',
  'connectors.category.timeTracking': 'Śledzenie czasu',
  'connectors.category.video': 'Wideo',
  'connectors.category.whiteboard': 'Tablica',
  'connectors.categoryLabel': 'Kategoria',
  'connectors.providerLabel': 'Dostawca',
  'connectors.toolsSection': 'Narzędzia',
  'connectors.toolsLoading': 'Ładowanie narzędzi…',
  'connectors.noToolsAvailable': 'Brak dostępnych narzędzi. Po połączeniu odkryjesz możliwości tej integracji.',
  'connectors.toolDetailsUnavailable': 'Tool details are unavailable, but this connector reports {n} tools.',
  'connectors.loadMoreTools': 'Load more tools',
  'connectors.openDetailsAria': 'Otwórz szczegóły {name}',
  'connectors.toolsBadgeNone': 'Brak narzędzi',
  'connectors.toolsBadgeOne': '{n} narzędzie',
  'connectors.toolsBadgeMany': '{n} narzędzi',
  'connectors.searchPlaceholder': 'Szukaj konektorów…',
  'connectors.searchAriaLabel': 'Szukaj konektorów po nazwie, dostawcy lub narzędziu',
  'connectors.searchClear': 'Wyczyść wyszukiwanie',
  'connectors.emptyNoMatchTitle': 'Brak konektorów pasujących do „{query}”',
  'connectors.emptyNoMatchBody': 'Spróbuj innego słowa kluczowego lub wyczyść wyszukiwanie, aby zobaczyć pełny katalog.',
  'connectors.emptyNoMatchAction': 'Wyczyść wyszukiwanie',

  'newproj.tabPrototype': 'Prototyp',
  'newproj.tabDeck': 'Prezentacja',
  'newproj.tabTemplate': 'Z szablonu',
  'newproj.tabMedia': 'Multimedia',
  'newproj.tabOther': 'Inne',
  'newproj.titlePrototype': 'Nowy prototyp',
  'newproj.titleDeck': 'Nowa prezentacja',
  'newproj.titleTemplate': 'Zacznij od szablonu',
  'newproj.titleImage': 'Nowy obraz',
  'newproj.titleVideo': 'Nowe wideo',
  'newproj.titleAudio': 'Nowy dźwięk',
  'newproj.titleMedia': 'Nowe multimedia',
  'newproj.titleOther': 'Nowy projekt',
  'newproj.namePlaceholder': 'Nazwa projektu',
  'newproj.fidelityLabel': 'Wierność (Fidelity)',
  'newproj.fidelityWireframe': 'Szkic (Wireframe)',
  'newproj.fidelityHigh': 'Wysoka wierność (Hi-Fi)',
  'newproj.toggleSpeakerNotes': 'Użyj notatek prelegenta',
  'newproj.toggleSpeakerNotesHint': 'Mniej tekstu na slajdach — główne punkty w notatkach.',
  'newproj.toggleAnimations': 'Dołącz animacje',
  'newproj.toggleAnimationsHint':
      'Dodaj ruch (wejście, najechanie, przejścia) do szablonu.',
  'newproj.templateLabel': 'Szablon',
  'newproj.noTemplatesTitle': 'Brak szablonów',
  'newproj.noTemplatesBody':
      'Otwórz dowolny projekt, a następnie użyj menu Udostępnij w przeglądarce plików, aby przekonwertować go na szablon. Szablony pojawią się tutaj.',
  'newproj.savedTemplate': 'Zapisany szablon',
  'newproj.fileSingular': 'plik',
  'newproj.filePlural': 'pliki',
  'newproj.create': 'Utwórz',
  'newproj.createFromTemplate': 'Utwórz z szablonu',
  'newproj.createDisabledTitle':
      'Najpierw zapisz projekt jako szablon (menu Udostępnij wewnątrz projektu).',
  'newproj.importClaudeZip': 'Importuj Claude Design ZIP',
  'newproj.importClaudeZipTitle': 'Importuj eksport .zip z Claude Design',
  'newproj.importingClaudeZip': 'Importowanie…',
  'newproj.privacyFooter': 'Domyślnie tylko Ty widzisz swój projekt.',
  'newproj.designSystem': 'System projektowania',
  'newproj.dsNoneFreeform': 'Brak — styl dowolny',
  'newproj.dsNoneSubtitleEmpty': 'Brak tokenów systemowych, wybierz własną paletę',
  'newproj.dsNoneSubtitleSelected': 'Pomiń tokeny systemowe. Agent dobierze własną paletę.',
  'newproj.dsCategoryFallback': 'System projektowania',
  'newproj.dsSearch': 'Szukaj systemów projektowania…',
  'newproj.dsModeAria': 'Tryb wyboru',
  'newproj.dsModeSingle': 'Pojedynczy',
  'newproj.dsModeMulti': 'Wiele',
  'newproj.dsNoneTitle': 'Brak — styl dowolny',
  'newproj.dsNoneSub': 'Pomiń tokeny systemowe. Agent dobierze własną paletę.',
  'newproj.dsEmpty': 'Brak systemów projektowania pasujących do „{query}”.',
  'newproj.dsFootSingular': 'służy tylko jako inspiracja.',
  'newproj.dsFootPlural': 'służą tylko jako inspiracja.',
  'newproj.dsFootClear': 'Wyczyść',
  'newproj.dsBadgeDefault': 'DOMYŚLNY',
  'newproj.dsPrimaryFallback': 'Główny',
  'newproj.surfaceImage': 'Obraz',
  'newproj.surfaceVideo': 'Wideo',
  'newproj.surfaceAudio': 'Dźwięk',
  'newproj.modelLabel': 'Model',
  'newproj.modelSearch': 'Szukaj modeli…',
  'newproj.modelEmpty': 'Brak pasujących modeli.',
  'newproj.modelRecommended': 'Zalecany',
  'newproj.modelMissingTitle': 'Wybierz model',
  'newproj.modelMissingSub': 'Wybierz model dla tej powierzchni.',
  'newproj.aspectLabel': 'Proporcje',
  'newproj.videoLengthLabel': 'Długość',
  'newproj.videoLengthSeconds': '{n}s',
  'newproj.audioKindLabel': 'Rodzaj dźwięku',
  'newproj.audioKindMusic': 'Muzyka',
  'newproj.audioKindSpeech': 'Mowa / TTS',
  'newproj.audioKindSfx': 'Efekty (SFX)',
  'newproj.audioDurationLabel': 'Czas trwania',
  'newproj.audioDurationSeconds': '{n}s',
  'newproj.voiceLabel': 'Głos',
  'newproj.voicePlaceholder': 'ID głosu dostawcy, opcjonalnie',
  'newproj.connectorsLabel': 'Konektory',
  'newproj.connectorsHint': 'Źródła danych, z których może korzystać ten artefakt.',
  'newproj.connectorsEmptyTitle': 'Brak skonfigurowanych konektorów',
  'newproj.connectorsEmptyBody': 'Połącz źródło danych, aby artefakt live używał prawdziwych danych zamiast placeholderów.',
  'newproj.connectorsEmptyCta': 'Skonfiguruj konektory →',
  'newproj.connectorsLoading': 'Ładowanie konektorów…',
  'newproj.connectorsCountOne': '{n} połączony',
  'newproj.connectorsCountMany': '{n} połączonych',
  'newproj.connectorsManage': 'Zarządzaj',
  'newproj.promptTemplateLabel': 'Szablon referencyjny',
  'newproj.promptTemplateNoneTitle': 'Brak — napisz własny',
  'newproj.promptTemplateNoneSub': 'Pomiń galerię, opisz własne zadanie',
  'newproj.promptTemplateRefSub': 'Szablon referencyjny',
  'newproj.promptTemplateSearch': 'Szukaj szablonów…',
  'newproj.promptTemplateEmpty': 'Nie zainstalowano jeszcze szablonów dla tego typu powierzchni.',
  'newproj.promptTemplateBodyLabel': 'Polecenie (możesz go dostosować)',
  'newproj.promptTemplateOptimizeHint':
      'Możesz edytować wszystko — Twoje zmiany zostaną uwzględnione w instrukcjach dla agenta.',
  'newproj.promptTemplateBodyEmpty':
      'Pusta treść — agent nie otrzyma referencji do szablonu.',
  'newproj.deleteTemplateTitle': 'Usuń szablon',
  'newproj.deleteTemplateConfirm': 'Usunąć „{name}"? Tej operacji nie można cofnąć.',
  'newproj.deleteTemplateConfirmCta': 'Usuń szablon',
  'newproj.deleteTemplateError':
    'Nie udało się usunąć tego szablonu. Spróbuj ponownie.',

  'designs.subRecent': 'Ostatnie',
  'designs.subYours': 'Twoje projekty',
  'designs.filterAria': 'Filtruj projekty',
  'designs.searchPlaceholder': 'Szukaj…',
  'designs.emptyNoProjects': 'Brak projektów. Utwórz jeden po lewej stronie.',
  'designs.emptyNoMatch': 'Brak projektów pasujących do wyszukiwania.',
  'designs.deleteTitle': 'Usuń projekt',
  'designs.deleteConfirm': 'Usunąć „{name}”?',
  'designs.cardFreeform': 'styl dowolny',
  'designs.status.notStarted': 'Nie rozpoczęto',
  'designs.status.queued': 'W kolejce',
  'designs.status.running': 'Uruchomiony',
  'designs.status.awaitingInput': 'Wymaga danych',
  'designs.status.succeeded': 'Zakończono',
  'designs.status.published': 'Opublikowano',
  'designs.status.failed': 'Błąd',
  'designs.status.canceled': 'Anulowano',
  'designs.viewToggleAria': 'Tryb widoku',
  'designs.viewGrid': 'Widok siatki',
  'designs.viewKanban': 'Widok tablicy',
  'designs.kanbanEmptyColumn': 'Brak projektów',
  'designs.deleteAria': 'Usuń projekt {name}',
  'designs.menuMore': 'More actions',
  'designs.menuRename': 'Rename',
  'designs.menuDelete': 'Delete',
  'designs.renamePrompt': 'New name for "{name}"',
  'designs.selectMode': 'Select',
  'designs.cancelSelect': 'Cancel',
  'designs.deleteSelected': 'Delete selected',
  'designs.selectedCount': '{n} selected',
  'designs.deleteSelectedConfirm': 'Delete {n} project(s)?',
  'designs.deleteSelectedSuccess': '{n} project(s) deleted successfully.',
  'designs.deleteSelectedPartial': 'Deleted {deleted} project(s); {failed} failed.',
  'designs.tagPrototype': 'Prototype',
  'designs.tagLiveArtifact': 'Live Artifact',
  'designs.tagSlide': 'Slide',
  'designs.tagMedia': 'Media',
  'designs.renameTitle': 'Rename project',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Cancel',

  'examples.typeLabel': 'Typ',
  'examples.surfaceLabel': 'Powierzchnia',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Obraz',
  'examples.surfaceVideo': 'Wideo',
  'examples.surfaceAudio': 'Dźwięk',
  'examples.scenarioLabel': 'Scenariusz',
  'examples.modeAll': 'Wszystkie',
  'examples.modePrototypeDesktop': 'Prototypy · Desktop',
  'examples.modePrototypeMobile': 'Prototypy · Mobile',
  'examples.modeDeck': 'Slajdy',
  'examples.modeDocument': 'Dokumenty i szablony',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Live',
  'examples.scenarioGeneral': 'Ogólne',
  'examples.scenarioEngineering': 'Inżynieria',
  'examples.scenarioProduct': 'Produkt',
  'examples.scenarioDesign': 'Design',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Sprzedaż',
  'examples.scenarioFinance': 'Finanse',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Operacje',
  'examples.scenarioSupport': 'Wsparcie',
  'examples.scenarioLegal': 'Prawo',
  'examples.scenarioEducation': 'Edukacja',
  'examples.scenarioPersonal': 'Osobiste',
  'examples.emptyNoSkills': 'Brak dostępnych umiejętności. Czy daemon jest uruchomiony?',
  'examples.searchPlaceholder': 'Szukaj przykładów…',
  'examples.searchAria': 'Szukaj przykładów po nazwie',
  'examples.emptyNoMatch': 'Brak przykładów pasujących do filtrów.',
  'examples.openPreview': '⤢ Otwórz podgląd',
  'examples.loadingPreview': 'Ładowanie podglądu…',
  'examples.hoverPreview': 'Najedź, aby zobaczyć podgląd',
  'examples.usePrompt': 'Użyj tego promptu',
  'examples.previewModalTitle': 'Pełny podgląd (okno)',
  'examples.shareTitle': 'Udostępnij ten przykład',
  'examples.shareLoadFirst': 'Najedź, aby najpierw załadować podgląd',
  'examples.unavailablePlaceholder': 'Brak dołączonego podglądu {kind} — otwórz, aby dowiedzieć się więcej',
  'examples.shareUnavailable': 'Brak dołączonego podglądu {kind} do udostępnienia',
  'examples.shareMenu': 'Udostępnij ▾',
  'examples.exportPdfAllSlides': 'Eksportuj jako PDF (wszystkie slajdy)',
  'examples.exportPptxLocked': 'Eksportuj jako PPTX… (najpierw otwórz szablon)',
  'examples.tagSlideDeck': 'Prezentacja',
  'examples.tagTemplate': 'Szablon',
  'examples.tagDesignSystem': 'System projektowania',
  'examples.tagMobilePrototype': 'Prototyp mobilny',
  'examples.tagDesktopPrototype': 'Prototyp desktopowy',
  'examples.tagImage': 'Obraz',
  'examples.tagVideo': 'Wideo',
  'examples.tagAudio': 'Dźwięk',
  'examples.previewLabel': 'Podgląd',

  'ds.surfaceLabel': 'Powierzchnia',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Obraz',
  'ds.surfaceVideo': 'Wideo',
  'ds.surfaceAudio': 'Dźwięk',
  'ds.searchPlaceholder': 'Szukaj systemów projektowania…',
  'ds.emptyNoMatch': 'Brak systemów projektowania pasujących do wyszukiwania.',
  'ds.badgeDefault': 'DOMYŚLNY',
  'ds.preview': 'Podgląd',
  'ds.previewTitle': 'Podgląd systemu projektowania',
  'ds.categoryAll': 'Wszystkie',
  'ds.categoryUncategorized': 'Niekategoryzowane',
  'ds.showcase': 'Galeria',
  'ds.tokens': 'Tokeny',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Ładowanie DESIGN.md…',

  'avatar.title': 'Konto i ustawienia',
  'avatar.localCli': 'Lokalne CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Użyj lokalnego CLI',
  'avatar.useApi': 'Użyj API · BYOK',
  'avatar.codeAgent': 'Agent kodu',
  'avatar.rescan': 'Skanuj PATH ponownie',
  'avatar.settings': 'Ustawienia',
  'avatar.backToProjects': 'Wróć do projektów',
  'avatar.metaActive': 'aktywny',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'wybrano',
  'avatar.noAgentSelected': 'nie wybrano agenta',
  'avatar.modelSection': 'Model',
  'avatar.modelLabel': 'Model',
  'avatar.reasoningLabel': 'Rozumowanie',
  'avatar.customSuffix': '(własny)',

  'inlineSwitcher.chipTitle': 'Przełącz CLI / model',
  'inlineSwitcher.chipCli': 'Lokalne CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'domyślny',
  'inlineSwitcher.noAgent': 'brak agenta',
  'inlineSwitcher.modeLabel': 'Tryb',
  'inlineSwitcher.agentLabel': 'Agent',
  'inlineSwitcher.providerLabel': 'Dostawca',
  'inlineSwitcher.modelLabel': 'Model',
  'inlineSwitcher.useCli': 'Użyj lokalnego CLI',
  'inlineSwitcher.useByok': 'Użyj własnego klucza API',
  'inlineSwitcher.daemonOffline': 'Daemon offline — otwórz ustawienia',
  'inlineSwitcher.noAgentsDetected': 'Nie wykryto CLI w PATH',
  'inlineSwitcher.openSettingsForModel': 'Skonfiguruj dostawcę w Ustawieniach',
  'inlineSwitcher.missingApiKey': 'Brak klucza API — dodaj go w Ustawieniach.',
  'inlineSwitcher.openFullSettings': 'Otwórz ustawienia wykonania',
  'inlineSwitcher.customSuffix': '(własny)',

  'project.backToProjects': 'Wróć do projektów',
  'project.metaFreeform': 'styl dowolny',
  'project.resizeChatPanel': 'Zmień rozmiar panelu czatu',
  'project.instructionsActive': 'Aktywne — dołączane do każdej wiadomości',
  'chat.tabChat': 'Czat',
  'chat.tabComments': 'Komentarze',
  'chat.commentsSoon': 'Komentarze — wkrótce',
  'chat.comments.attached': 'Dołączone do czatu',
  'chat.comments.emptyAttached': 'Brak dołączonych komentarzy.',
  'chat.comments.saved': 'Zapisane komentarze',
  'chat.comments.emptySaved': 'Brak zapisanych komentarzy.',
  'chat.comments.add': 'Dodaj',
  'chat.comments.addAll': 'Dodaj wszystkie',
  'chat.comments.remove': 'Usuń',
  'chat.comments.placeholder': 'Skomentuj ten element…',
  'chat.comments.addSend': 'Dodaj i wyślij',
  'chat.comments.updateSend': 'Zaktualizuj i wyślij',
  'chat.comments.removeAttachment': 'Usuń załącznik komentarza',
  'chat.comments.removeAttachmentAria': 'Usuń załącznik komentarza dla {name}',
  'chat.comments.comment': 'Comment',
  'chat.comments.sendToChat': 'Send to chat',
  'chat.comments.sending': 'Sending…',
  'chat.comments.edit': 'Edit',
  'chat.comments.select': 'Select',
  'chat.comments.deselect': 'Deselect',
  'chat.comments.nSelected': '{n} selected',
  'chat.comments.pin': 'Pin',
  'chat.comments.addNote': 'Add note',
  'chat.comments.savedToast': 'Comment saved',
  'chat.comments.pinSavedToast': 'Pin saved',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} captured items',
  'chat.comments.clear': 'Clear',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.conversationsTitle': 'Rozmowy',
  'chat.conversationsAria': 'Historia rozmów',
  'chat.newConversation': 'Nowa rozmowa',
  'chat.newConversationsTitle': 'Nowa rozmowa',
  'chat.conversationsHeading': 'Rozmowy',
  'chat.new': 'Nowa',
  'chat.emptyConversations': 'Brak rozmów.',
  'chat.deleteConversation': 'Usuń rozmowę',
  'chat.renameConversationLabel': 'Zmień nazwę „{title}”',
  'chat.deleteConversationConfirm':
      'Usunąć „{title}”? Spowoduje to usunięcie wszystkich wiadomości.',
  'chat.untitledConversation': 'Rozmowa bez tytułu',
  'chat.startTitle': 'Zacznij rozmowę',
  'chat.startHint': "Opisz, co chcesz wygenerować, albo zacznij od jednego z tych przykładów:",
  'chat.fillInputTitle': 'Kliknij, aby wypełnić pole tekstowe',
  'chat.jumpToLatest': 'Skocz do najnowszych',
  'chat.scrollToLatest': 'Przewiń do najnowszych',
  'chat.you': 'Ty',
  'chat.openFile': 'Otwórz {name}',
  'chat.copyPrompt': 'Kopiuj prompt',
  'chat.copyDone': 'Skopiowano!',
  'chat.composerPlaceholder': "Opisz, co chcesz wygenerować…",
  'chat.composerHint': "⌘/Ctrl + Enter, aby wysłać · podaj cel, treść, styl i format",
  'chat.cliSettingsTitle': 'Ustawienia CLI i modelu',
  'chat.cliSettingsAria': 'Otwórz ustawienia CLI i modelu',
  'chat.attachTitle': 'Załącz pliki (lub wklej / przeciągnij)',
  'chat.attachAria': 'Załącz pliki',
  'chat.importTitle': 'Importuj źródła (wkrótce)',
  'chat.importLabel': 'Importuj',
  'chat.importComingSoon': 'Wkrótce',
  'chat.importSoon': 'Wkrótce',
  'chat.importFig': 'Prześlij plik .fig',
  'chat.importGitHub': 'Połącz z GitHub',
  'chat.importWeb': 'Pobierz element webowy',
  'chat.importFolder': 'Połącz folder z kodem',
  'chat.importSkills': 'Umiejętności i systemy projektowania',
  'chat.importProject': 'Reference another project',
  'chat.linkedFolderRemoveAria': 'Usuń połączony folder {path}',
  'chat.linkedFolderNotFound': 'Folder nie istnieje',
  'chat.linkedFolderAlready': 'Ten folder jest już połączony',
  'chat.linkedFolderPickError': 'Nie można otworzyć wyboru folderu',
  'chat.queuedHeader': 'Queued',
  'chat.queuedToSend': 'to Send',
  'chat.queuedEditQueuedTaskAria': 'Edit queued task',
  'chat.queuedSave': 'Save',
  'chat.queuedCancel': 'Cancel',
  'chat.queuedEdit': 'Edit',
  'chat.queuedMore': 'more queued',
  'chat.queuedFollowUpFallback': 'Queued follow-up',
  'chat.send': 'Wyślij',
  'chat.stop': 'Zatrzymaj',
  'chat.removeAria': 'Usuń {name}',
  'chat.example1Title': 'Prezentacja redakcyjna (Pitch deck)',
  'chat.example1Tag': 'Magazyn',
  'chat.example1Prompt':
      '10-slajdowa prezentacja (pitch deck) dla studia projektowego zbierającego rundę seed — układ typu Swiss-grid, duże nagłówki szeryfowe z pogrubionymi inicjałami, numery sekcji o stałej szerokości znaków, dużo wolnej przestrzeni i slajdy ze zdjęciami na cały ekran przeplatane tymi z dużą ilością tekstu. Okładka, wizja, rynek, produkt, trakcja, zespół, zapytanie, kontakt.',
  'chat.example2Title': 'Dashboard analityczny SaaS',
  'chat.example2Tag': 'Dane',
  'chat.example2Prompt':
      'Gęsty dashboard analityczny dla SaaS-a z narzędziami dla programistów — pasek KPI ze zmianami tydzień do tygodnia, dwa wykresy liniowe (MRR i aktywne obszary robocze), mapa cieplna użycia na świecie, siatka retencji kohortowej, tabela liderów wśród klientów i kanał zdarzeń w czasie rzeczywistym. Ciemny motyw, cyfry o stałej szerokości, akcenty typu sparkline.',
  'chat.example3Title': 'Raport roczny (long-scroll)',
  'chat.example3Tag': 'Edytorskie',
  'chat.example3Prompt':
      'Interaktywny raport roczny dla organizacji klimatycznej — układ typu long-scroll mieszający bloki z dużymi cytatami, wizualizacje danych (wykresy słupkowe, animowane liczniki, mapa choropletowa lokalizacji projektów), przerywniki fotograficzne, lista darczyńców i końcowe wezwanie do działania. Nowoczesny tekst szeryfowy, etykiety wykresów bezszeryfowe, ziemista paleta kolorów.',

  'preview.shareMenu': 'Udostępnij',
  'preview.exportMenu': 'Export',
  'preview.shareTemplateBadge': 'Template',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copy template link',
  'preview.copyShareText': 'Copy share text',
  'preview.shareSocialGroup': 'Share to social',
  'preview.shareCopyGroup': 'Copy',
  'preview.shareExportGroup': 'Export files',
  'preview.shareCopied': 'Copied',
  'preview.shareCopyFailed': 'Copy failed',
  'preview.shareTextDefault': 'Open Design template: {title}',
  'preview.openInNewTab': 'Otwórz w nowej karcie',
  'preview.exit': '⤓ Wyjdź',
  'preview.fullscreen': '⤢ Pełny ekran',
  'preview.closeTitle': 'Zamknij (Esc)',
  'preview.loading': 'Ładowanie {label}…',
  'preview.errorTitle': 'Nie udało się załadować tego przykładu.',
  'preview.errorBody': 'Nie udało się pobrać kodu HTML przykładu. Upewnij się, że Open Design jest uruchomiony, i spróbuj ponownie.',
  'preview.retry': 'Spróbuj ponownie',
  'preview.unavailableTitle': 'Brak dołączonego podglądu dla tej umiejętności.',
  'preview.unavailableBody': 'Ta umiejętność tworzy {kind} wynik — uruchom prompt w czacie, aby go wygenerować.',
  'preview.showSidebar': 'Pokaż {label}',
  'preview.hideSidebar': 'Ukryj {label}',

  'misc.savedTemplate': 'Zapisany szablon',
  'misc.primary': 'Główny',
  'misc.designSystem': 'System projektowania',

  'workspace.designFiles': 'Pliki projektu',
  'workspace.focusMode': 'Focus workspace',
  'workspace.showChat': 'Show chat',
  'workspace.closeTab': 'Zamknij kartę',
  'workspace.deleteFileConfirm': 'Usunąć „{name}” z folderu projektu?',
  'workspace.deleteSelectedFilesConfirm': 'Usunąć {n} wybranych plików z folderu projektu?',
  'workspace.deleteSelectedFilesPartial': 'Nie udało się usunąć {n} plików.',
  'workspace.openFromDesignFiles': 'Otwórz plik z',
  'workspace.designFilesLink': 'Pliki projektu',
  'workspace.loadingSketch': 'Ładowanie szkicu…',
  'designFiles.title': 'Pliki projektu',
  'designFiles.upload': 'Prześlij pliki',
  'designFiles.pasteText': 'Wklej jako plik tekstowy',
  'designFiles.newSketch': 'Nowy szkic',
  'designFiles.empty': 'Twoje kreacje pojawią się tutaj',
  'designFiles.refresh': 'Odśwież',
  'designFiles.delete': 'Usuń',
  'designFiles.searchPlaceholder': 'Szukaj plików…',
  'designFiles.up': 'W górę',
  'designFiles.back': 'Wstecz',
  'designFiles.crumbs': 'projekt',
  'designFiles.rowMenu': 'Menu wiersza',
  'designFiles.openInTab': 'Otwórz w karcie',
  'designFiles.download': 'Pobierz',
  'designFiles.downloadSelected': 'Pobierz {n} jako ZIP',
  'designFiles.clearSelection': 'Wyczyść zaznaczenie',
  'designFiles.selectPage': 'Zaznacz wszystko na stronie',
  'designFiles.selectAll': 'Zaznacz wszystko',
  'designFiles.deleteSelected': 'Usuń {n}',
  'designFiles.dropTitle': '⤓ Upuść pliki tutaj',
  'designFiles.dropDesc':
      'Obrazy, dokumenty, referencje lub foldery — agent użyje ich jako kontekstu.',
  'designFiles.upload.title': 'Prześlij pliki',
  'designFiles.paste.title': 'Wklej tekst jako plik',
  'designFiles.upload.label': 'Prześlij',
  'designFiles.paste.label': 'Wklej',
  'designFiles.previewOpen': 'Otwórz',
  'designFiles.previewClose': 'Zamknij podgląd',
  'designFiles.modified': 'Zmodyfikowano {time} · {size}',
  'designFiles.weeksAgo': '{n} tyg. temu',
  'designFiles.groupBy': 'Grupuj według',
  'designFiles.groupByKind': 'Typ',
  'designFiles.groupByModified': 'Modyfikacja',
  'designFiles.expandGroup': 'Rozwiń',
  'designFiles.collapseGroup': 'Zwiń',
  'designFiles.sectionPages': 'Strony',
  'designFiles.sectionScripts': 'Skrypty',
  'designFiles.sectionImages': 'Obrazy',
  'designFiles.sectionSketches': 'Szkice',
  'designFiles.sectionOther': 'Inne',
  'designFiles.modifiedToday': 'Dzisiaj',
  'designFiles.modifiedYesterday': 'Wczoraj',
  'designFiles.modifiedPrevious7Days': 'Ostatnie 7 dni',
  'designFiles.modifiedPrevious30Days': 'Ostatnie 30 dni',
  'designFiles.modifiedOlder': 'Starsze',
  'designFiles.showMore': 'Pokaż +{n} więcej',
  'designFiles.kindHtml': 'Strona HTML',
  'designFiles.kindImage': 'Obraz',
  'designFiles.kindSketch': 'Szkic',
  'designFiles.kindText': 'Tekst',
  'designFiles.kindCode': 'Skrypt',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Dokument',
  'designFiles.kindPresentation': 'Prezentacja',
  'designFiles.kindSpreadsheet': 'Arkusz kalkulacyjny',
  'designFiles.kindBinary': 'Plik binarny',
  'designFiles.kindFolder': 'Folder',
  'designFiles.folderCount': '{n} plików',
  'designFiles.colName': 'Nazwa',
  'designFiles.colKind': 'Rodzaj',
  'designFiles.colModified': 'Zmodyfikowano',
  'designFiles.perPage': 'Pokaż',
  'designFiles.all': 'Wszystkie',
  'designFiles.prev': 'Poprzednia',
  'designFiles.next': 'Następna',
  'designFiles.jumpToPage': 'Przejdź do strony',
  'designFiles.pageInfo': '{start}–{end} z {total}',
  'quickSwitcher.placeholder': 'Otwórz plik…',
  'quickSwitcher.empty': 'Brak plików w tym projekcie',
  'quickSwitcher.noMatches': 'Brak wyników',
  'quickSwitcher.navigate': 'nawiguj',
  'quickSwitcher.open': 'otwórz',
  'quickSwitcher.close': 'zamknij',
  'pasteDialog.title': 'Wklej tekst',
  'pasteDialog.hint': 'Zapisano w folderze projektu. Wybierz dowolną nazwę.',
  'pasteDialog.fileNameLabel': 'Nazwa pliku',
  'pasteDialog.namePlaceholder': 'notatki.txt',
  'pasteDialog.contentLabel': 'Treść',
  'pasteDialog.contentPlaceholder': 'Wklej cokolwiek…',
  'pasteDialog.save': 'Zapisz',
  'pasteDialog.cancel': 'Anuluj',
  'sketch.save': 'Zapisz szkic',
  'sketch.cancel': 'Anuluj',
  'sketch.saving': 'Zapisywanie…',
  'sketch.saved': 'Zapisano',
  'sketch.tooltipDirty': 'Niezapisane zmiany',
  'sketch.tooltipClean': 'Zapisano',
  'fileViewer.empty': 'Wybierz plik, aby go wyświetlić.',
  'fileViewer.loading': 'Ładowanie…',
  'fileViewer.exportPptx': 'Eksportuj jako PPTX',
  'fileViewer.openInNewTab': 'Otwórz w nowej karcie',
  'fileViewer.copyPath': 'Kopiuj ścieżkę',
  'fileViewer.copied': 'Skopiowano!',
  'fileViewer.share': 'Udostępnij',
  'fileViewer.binaryMeta': 'Binarny · {size}',
  'fileViewer.binaryNote':
      'Plik binarny ({size} bajtów). Pobierz go lub otwórz z dysku, aby sprawdzić zawartość.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Dokument',
  'fileViewer.presentationMeta': 'Prezentacja',
  'fileViewer.spreadsheetMeta': 'Arkusz kalkulacyjny',
  'fileViewer.previewUnavailable': 'Podgląd niedostępny. Pobierz lub otwórz plik, aby go sprawdzić.',
  'fileViewer.download': 'Pobierz',
  'fileViewer.open': 'Otwórz',
  'fileViewer.imageMeta': 'Obraz · {size}',
  'fileViewer.reactMeta': 'Komponent React · {size}',
  'fileViewer.sketchMeta': 'Szkic · {size}',
  'fileViewer.markdownStreamingMeta': 'Podgląd na żywo…',
  'fileViewer.markdownErrorMeta': 'Podgląd może być niepełny (błąd generowania).',
  'fileViewer.markdownStreamingStatus': 'Strumieniowanie… wyświetlanie częściowego markdownu.',
  'fileViewer.markdownErrorStatus': 'Błąd generowania. Wyświetlanie ostatniej dostępnej treści.',
  'fileViewer.videoMeta': 'Wideo · {size}',
  'fileViewer.audioMeta': 'Dźwięk · {size}',
  'fileViewer.reload': 'Odśwież',
  'fileViewer.reloadDisk': 'Odśwież z dysku',
  'fileViewer.copy': 'Kopiuj',
  'fileViewer.copyTitle': 'Kopiuj zawartość pliku',
  'fileViewer.saveDisabled': 'Zapisz (widok tylko do odczytu)',
  'fileViewer.save': 'Zapisz',
  'fileViewer.preview': 'Podgląd',
  'fileViewer.source': 'Źródło',
  'fileViewer.tweaks': 'Poprawki',
  'fileViewer.tweaksUnavailable': 'Brak panelu poprawek w tym artefakcie',
  'fileViewer.jsxModuleTitle': 'Brak samodzielnego podglądu',
  'fileViewer.jsxModuleBody': 'Ten plik to moduł komponentu ładowany przez inną stronę.',
  'fileViewer.jsxModuleCta': 'Otwórz stronę, która go renderuje:',
  'fileViewer.comment': 'Komentarz',
  'fileViewer.edit': 'Edytuj',
  'fileViewer.draw': 'Rysuj',
  'manualEdit.layers': "Layers",
  'manualEdit.editableCount': "{count} editable",
  'manualEdit.hiddenBadge': "Hidden",
  'manualEdit.title': "Manual editor",
  'manualEdit.selectLayer': "Select a layer",
  'manualEdit.empty': "Click an element in the preview or choose a layer.",
  'manualEdit.noEditableLayers': "No editable layers found.",
  'manualEdit.noClass': "no class",
  'manualEdit.tabsAria': "Manual edit tabs",
  'manualEdit.tabContent': "Content",
  'manualEdit.tabStyle': "Style",
  'manualEdit.tabAttributes': "Attributes",
  'manualEdit.tabHtml': "Html",
  'manualEdit.tabSource': "Source",
  'manualEdit.attributesJson': "Attributes JSON",
  'manualEdit.selectedHtml': "Selected element HTML",
  'manualEdit.fullSource': "Full artifact source",
  'manualEdit.applyContent': "Apply Content",
  'manualEdit.applyStyle': "Apply Style",
  'manualEdit.applyAttributes': "Apply Attributes",
  'manualEdit.applyHtml': "Apply HTML",
  'manualEdit.applySource': "Apply Source",
  'manualEdit.invalidAttributes': "Invalid attributes JSON.",
  'manualEdit.changes': "Changes",
  'manualEdit.undo': "Undo",
  'manualEdit.redo': "Redo",
  'manualEdit.noChanges': "No manual edits yet.",
  'manualEdit.imageUrl': "Image URL",
  'manualEdit.altText': "Alt text",
  'manualEdit.label': "Label",
  'manualEdit.text': "Text",
  'manualEdit.href': "Href",
  'manualEdit.textColor': "Text color",
  'manualEdit.background': "Background",
  'manualEdit.fontSize': "Font size",
  'manualEdit.weight': "Weight",
  'manualEdit.align': "Align",
  'manualEdit.padding': "Padding",
  'manualEdit.margin': "Margin",
  'manualEdit.radius': "Radius",
  'manualEdit.border': "Border",
  'manualEdit.width': "Width",
  'manualEdit.minHeight': "Min height",
  'fileViewer.zoomOut': 'Pomniejsz',
  'fileViewer.zoomIn': 'Powiększ',
  'fileViewer.resetZoom': 'Resetuj powiększenie',
  'fileViewer.viewportAria': 'Preview viewport',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Full-width desktop preview',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Tablet preview at 820 × 1180 (modern portrait baseline)',
  'fileViewer.viewportMobile': 'Mobile',
  'fileViewer.viewportMobileTitle': 'Mobile preview at 390 × 844',
  'fileViewer.reloadAria': 'Odśwież',
  'fileViewer.previousSlide': 'Poprzedni slajd',
  'fileViewer.nextSlide': 'Następny slajd',
  'fileViewer.slideNavAria': 'Nawigacja slajdów',
  'fileViewer.present': 'Prezentuj',
  'fileViewer.presentInTab': 'W tej karcie',
  'fileViewer.presentFullscreen': 'Pełny ekran',
  'fileViewer.presentNewTab': 'Nowa karta',
  'fileViewer.exitPresentation': 'Wyjdź z prezentacji',
  'fileViewer.shareLabel': "Udostępnij",
  'fileViewer.exportPdf': 'Eksportuj jako PDF',
  'fileViewer.exportPdfAllSlides': 'Eksportuj jako PDF (wszystkie slajdy)',
  'fileViewer.exportPptxBusy': 'Poczekaj, aż bieżąca tura zostanie zakończona.',
  'fileViewer.exportPptxHint':
      'Wyślij prośbę do agenta o przekonwertowanie tego projektu na PPTX.',
  'fileViewer.exportPptxNa': 'Eksport do PPTX nie jest tutaj dostępny.',
  'fileViewer.exportZip': 'Pobierz jako .zip',
  'fileViewer.exportHtml': 'Eksportuj jako samodzielny HTML',
  'fileViewer.exportMd': 'Eksportuj jako Markdown',
  'fileViewer.exportImage': 'Eksportuj jako obraz',
  'fileViewer.exportImageFailed': 'Przechwytywanie obrazu nie powiodło się. Spróbuj ponownie lub użyj narzędzia do zrzutów ekranu w przeglądarce.',
  'fileViewer.exportJsx': 'Eksportuj jako JSX',
  'fileViewer.exportReactHtml': 'Eksportuj podgląd jako HTML',
  'fileViewer.saveAsTemplate': 'Zapisz jako szablon…',
  'fileViewer.savingTemplate': 'Zapisywanie szablonu…',
  'fileViewer.savedTemplate': 'Zapisano jako „{name}”',
  'fileViewer.savedTemplateFail': 'Nie udało się zapisać szablonu — spróbuj ponownie.',
  'fileViewer.templateNamePrompt': 'Nazwa szablonu',
  'fileViewer.templateNameDefault': 'Szablon bez tytułu',
  'fileViewer.templateDescPrompt':
      'Krótki opis (opcjonalnie — co czyni ten szablon użytecznym?)',
  'fileViewer.deployToVercel': 'Wdróż na Vercel',
  'fileViewer.redeployToVercel': 'Wdróż ponownie',
  'fileViewer.deployingToVercel': 'Wdrażanie na Vercel…',
  'fileViewer.deployProviderLabel': 'Dostawca',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'Wdróż na {provider}',
  'fileViewer.redeployToProvider': 'Wdróż ponownie na {provider}',
  'fileViewer.deployingToProvider': 'Wdrażanie na {provider}…',
  'fileViewer.preparingPublicLink': 'Przygotowywanie publicznego linku…',
  'fileViewer.copyDeployLink': 'Kopiuj link',
    'fileViewer.deployModalTitle': 'Wdróż',
  'fileViewer.deployModalSubtitle': 'Użyj konta wybranego dostawcy, aby wdrożyć ten podgląd HTML.',
  'fileViewer.vercelToken': 'Token Vercel',
  'fileViewer.vercelTokenGetLink': 'Pobierz token Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Wklej swój token Vercel',
  'fileViewer.vercelTokenReuseHint': 'Zapisany token zostanie użyty. Wprowadź nowy, aby go zastąpić.',
  'fileViewer.vercelTokenRequired': 'Najpierw wprowadź i zapisz token Vercel.',
  'fileViewer.cloudflareApiToken': 'Token API Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Pobierz token API Cloudflare',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Wklej swój token API Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'Zapisany token API Cloudflare zostanie użyty. Wprowadź nowy, aby go zastąpić.',
  'fileViewer.cloudflareApiTokenRequired': 'Najpierw wprowadź i zapisz token API Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Pages Edit is required for deploys. Zone Read is required to list domains. DNS Edit is only needed when binding a custom domain.',
  'fileViewer.vercelTeamId': 'ID zespołu',
  'fileViewer.vercelTeamSlug': 'Slug zespołu',
  'fileViewer.cloudflareAccountId': 'ID konta',
  'fileViewer.cloudflareAccountIdHint': 'Wymagane. ID konta znajdziesz w panelu Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Najpierw wprowadź i zapisz Cloudflare Account ID.',
  'fileViewer.cloudflareZoneLabel': 'Domain',
  'fileViewer.cloudflareZonePlaceholder': 'Save Cloudflare settings to load domains',
  'fileViewer.cloudflareZoneRequired': 'Select a Cloudflare domain first.',
  'fileViewer.cloudflareZonesLoading': 'Loading Cloudflare domains…',
  'fileViewer.cloudflareZonesRefresh': 'Refresh domains',
  'fileViewer.cloudflareZonesLoadFailed': 'Could not load Cloudflare domains.',
  'fileViewer.cloudflareZonesEmpty': 'No active full Cloudflare domains were found for this account.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Subdomain prefix',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Use one DNS label only: lowercase letters, numbers, and hyphens.',
  'fileViewer.cloudflareHostnamePreview': 'Custom domain preview: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Optional: choose a Cloudflare domain and prefix to bind a custom subdomain. pages.dev will still be available.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Custom domain',
  'fileViewer.optional': 'Opcjonalnie',
  'fileViewer.vercelPreviewOnly': 'Wdrożenia są obecnie dostępne tylko jako Podgląd (Preview).',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages używa Direct Upload.',
  'fileViewer.savingConfig': 'Zapisywanie…',
  'fileViewer.deployConfigSaveFailed': 'Nie udało się zapisać ustawień Vercel.',
  'fileViewer.deployFailed': 'Wdrożenie nie powiodło się. Sprawdź ustawienia Vercel i spróbuj ponownie.',
  'fileViewer.deployProviderConfigSaveFailed': 'Nie udało się zapisać ustawień {provider}.',
  'fileViewer.deployProviderFailed': 'Wdrożenie na {provider} nie powiodło się. Sprawdź ustawienia i spróbuj ponownie.',
  'fileViewer.deployResultLabel': 'Wdrożony URL',
  'fileViewer.deployLinkReady': 'Gotowe',
  'fileViewer.deployLinkPreparingLabel': 'Oczekiwanie na link publiczny',
  'fileViewer.deployLinkDelayed': 'Strona została wdrożona. Dostawca wciąż przygotowuje publiczny link.',
  'fileViewer.deployLinkFailed': 'Domena niestandardowa nie powiodła się',
  'fileViewer.deployLinkProtectedLabel': 'Ochrona wdrożenia włączona',
  'fileViewer.deployLinkProtected': 'Strona została wdrożona, ale ten link podglądu wymaga uwierzytelnienia. Wyłącz Deployment Protection albo użyj własnej domeny.',
  'fileViewer.retryLink': 'Ponów teraz',

  'questionForm.submit': 'Wyślij',
  'questionForm.skip': 'Pomiń',
  'questionForm.locked': 'Odpowiedziano',

  'conv.switch': 'Przełącz rozmowę',
  'conv.label': 'Rozmowa',
  'conv.heading': 'Rozmowy',
  'conv.new': '+ Nowa',
  'conv.empty': 'Brak rozmów.',
  'conv.untitled': 'Rozmowa bez tytułu',
  'conv.renameTooltip': 'Kliknij dwukrotnie, aby zmienić nazwę',
  'conv.delete': 'Usuń rozmowę',
  'conv.deleteConfirm': 'Usunąć „{title}”? Spowoduje to usunięcie wszystkich wiadomości.',

  'agentPicker.label': 'Agent',
  'agentPicker.modeChoose': 'Wybierz tryb wykonywania',
  'agentPicker.localCli': 'Lokalne CLI',
  'agentPicker.daemonOff': 'daemon wyłączony',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Wybierz wykrytego agenta CLI',
  'agentPicker.noAgents': 'brak agentów w PATH',
  'agentPicker.notInstalled': 'nie zainstalowano',
  'agentPicker.rescan': 'Ponownie skanuj lokalny PATH w poszukiwaniu agentów',

  'tool.openInTab': 'Otwórz {name} w karcie',
  'tool.open': 'otwórz',
  'tool.todos': 'Zadania',
  'tool.askQuestion': 'Pytanie',
  'tool.askQuestionSubmit': 'Wyślij',
  'tool.askQuestionPending': 'Czeka na Twoją odpowiedź',
  'tool.askQuestionAnswered': 'Udzielono odpowiedzi',
  'tool.todosExpand': 'Pokaż zadania',
  'tool.todosCollapse': 'Ukryj zadania',
  'tool.todosDone': 'Gotowe',
  'tool.todosDismiss': 'Zamknij listę zadań',
  'tool.write': 'Zapisz',
  'tool.edit': 'Edytuj',
  'tool.read': 'Czytaj',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Pobierz (Fetch)',
  'tool.search': 'Szukaj',
  'tool.lines': '{n} linii',
  'tool.changeSingular': 'zmiana',
  'tool.changePlural': 'zmiany',
  'tool.in': 'w {path}',
  'tool.hide': 'ukryj',
  'tool.output': 'wyjście',
  'tool.running': 'uruchomiony…',
  'tool.error': 'błąd',
  'tool.done': 'gotowe',

  'assistant.role': 'Asystent',
  'assistant.workingLabel': 'Pracuję',
  'assistant.doneLabel': 'Gotowe',
  'assistant.feedbackPrompt': 'Opinia',
  'assistant.feedbackPositive': 'Pomocne',
  'assistant.feedbackNegative': 'Niepomocne',
  'assistant.feedbackReasonTitle': 'Tell us why',
  'assistant.feedbackReasonPositiveMatched': 'Understood my request',
  'assistant.feedbackReasonPositiveVisual': 'Looks good',
  'assistant.feedbackReasonPositiveUseful': 'Useful structure',
  'assistant.feedbackReasonPositiveEasy': 'Easy to keep editing',
  'assistant.feedbackReasonPositiveDesignSystem': 'Followed the design system',
  'assistant.feedbackReasonNegativeMissed': 'Missed my request',
  'assistant.feedbackReasonNegativeVisual': 'Visual quality needs work',
  'assistant.feedbackReasonNegativeIncomplete': 'Incomplete output',
  'assistant.feedbackReasonNegativeHard': 'Hard to use',
  'assistant.feedbackReasonNegativeDesignSystem': 'Did not follow the design system',
  'assistant.feedbackReasonOther': 'Other',
  'assistant.feedbackReasonPlaceholder': 'Add a short note...',
  'assistant.feedbackReasonSubmit': 'Submit',
  'assistant.emptyResponseLabel': 'No output',
  'assistant.emptyResponseMessage': 'The provider ended the request without returning text or an artifact. Try another model or provider, check quota, or retry.',
  'assistant.unfinishedLabel': 'Zatrzymano z niedokończonymi zadaniami',
  'assistant.unfinishedSummary': 'pozostało {n} zadań',
  'assistant.unfinishedMore': '+{n} więcej',
  'assistant.continueRemaining': 'Kontynuuj pozostałe zadania',
  'assistant.outTokens': '{n} wysłano',
  'assistant.producedFiles': 'Pliki z tej tury',
  'assistant.openFile': 'Otwórz',
  'assistant.downloadFile': 'Pobierz',
  'assistant.thinking': 'Myślę',
  'assistant.systemReminder': 'Przypomnienie systemowe',
  'assistant.waitingFirstOutput': 'Oczekiwanie na pierwszą odpowiedź',
  'assistant.statusBootingAgent': 'Uruchamianie agenta',
  'assistant.statusStarting': 'Startowanie',
  'assistant.statusRequesting': 'Wysyłanie prośby',
  'assistant.statusThinking': 'Myślenie',
  'assistant.statusStreaming': 'Strumieniowanie',
  'assistant.slowHint':
      'Trwa to dłużej niż zwykle. Formularz zazwyczaj pojawia się w 5–10s — możesz zatrzymać i sformułować zapytanie inaczej.',
  'assistant.verbEditing': 'Edytowanie',
  'assistant.verbWriting': 'Zapisywanie',
  'assistant.verbReading': 'Czytanie',
  'assistant.verbSearching': 'Wyszukiwanie',
  'assistant.verbRunning': 'Uruchamianie',
  'assistant.verbTodos': 'Zadania',
  'assistant.verbFetching': 'Pobieranie',
  'assistant.verbCalling': 'Wywoływanie',

  'qf.answered': 'odpowiedziano',
  'qf.choose': 'Wybierz…',
  'qf.required': 'wymagane',
  'qf.lockedSubmitted':
      'Odpowiedzi wysłane — agent używa ich do końca sesji.',
  'qf.lockedPrev': 'Ten formularz pochodzi z poprzedniej tury.',
  'qf.hint':
      "Wybierz to, co pasuje. Pomiń opcjonalne pola, które Cię nie interesują — agent użyje rozsądnych domyślnych ustawień.",
  'qf.submitDefault': 'Wyślij odpowiedzi',
  'qf.submitDisabledTitle': 'Najpierw wypełnij wymagane pola',
  'qf.submitTitle': 'Wyślij odpowiedzi',
  'qf.cardSelected': 'wybrano',
  'qf.cardRefs': 'Ref:',
  'qf.cardSampleText': 'Zażółć gęślą jaźń · 0123',

  'sketch.toolSelect': 'Wybierz (brak akcji)',
  'sketch.toolPen': 'Pióro',
  'sketch.toolText': 'Tekst',
  'sketch.toolRect': 'Prostokąt',
  'sketch.toolArrow': 'Strzałka',
  'sketch.toolEraser': 'Gumka',
  'sketch.color': 'Kolor',
  'sketch.strokeSize': 'Grubość linii',
  'sketch.undo': 'Cofnij',
  'sketch.clear': 'Wyczyść',
  'sketch.close': 'Zamknij',
  'sketch.closeConfirm': 'Zamknąć szkic i odrzucić niezapisane zmiany?',
  'sketch.textPrompt': 'Tekst:',
  'sketch.textModalTitle': 'Dodaj tekst',

  'pet.title': 'Pupile',
  'pet.tabBuiltIn': 'Wbudowane',
  'pet.tabBuiltInHint': 'Towarzysze dołączeni do Open Design — wybierz jednego i adoptuj.',
  'pet.builtInEmpty': 'Wbudowane zwierzaki są teraz niedostępne. Odśwież zakładkę Społeczność, gdy daemon wróci.',
  'pet.tabCustom': 'Własny',
  'pet.tabCustomHint': 'Ustaw imię, glif, kolor lub wgraj sprite.',
  'pet.tabCommunity': 'Społeczność',
  'pet.tabCommunityHint': 'Pupile wyklute przez Codex — adoptuj albo wygeneruj nowego z AI.',
  'pet.tabsAria': 'Źródło pupila',
  'pet.subtitle': 'Adoptuj małego towarzysza, który unosi się nad Twoim workspace.',
  'pet.navTitle': 'Pupile',
  'pet.navHint': 'Adoptuj lub dostosuj',
  'pet.adopt': 'Adoptuj',
  'pet.adoptedBadge': 'Adoptowany',
  'pet.adoptCallout': 'Adoptuj pupila',
  'pet.changePet': 'Zmień pupila',
  'pet.wake': 'Obudź',
  'pet.tuck': 'Schowaj',
  'pet.wakeTitle': 'Obudź pupila — pokaż nakładkę.',
  'pet.tuckTitle': 'Schowaj pupila — ukryj nakładkę.',
  'pet.settingsTitle': 'Otwórz ustawienia pupila',
  'pet.useCustom': 'Użyj mojego pupila',
  'pet.customTitle': 'Stwórz własnego',
  'pet.customHint': 'Wybierz imię, symbol i kolor akcentu — nakładka aktualizuje się na żywo.',
  'pet.customGreetingPlaceholder': 'Powitanie od Twojego pupila…',
  'pet.fieldName': 'Imię',
  'pet.fieldGlyph': 'Symbol',
  'pet.fieldGlyphHint': 'Pojedyncze emoji wygląda najlepiej (np. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Powitanie',
  'pet.fieldAccent': 'Kolor akcentu',
  'pet.fieldAccentCustom': 'Własny kolor',
  'pet.fieldAccentDefault': 'Domyślny kolor akcentu',
  'pet.overlayAria': 'Towarzysz pupil',
  'pet.spriteAria': '{name} — przeciągnij, aby przesunąć, kliknij, aby porozmawiać',
  'pet.spriteTitle': 'Cześć od {name}! Kliknij, aby porozmawiać.',
  'pet.composerTitle': 'Pupile — obudź, schowaj lub wybierz',
  'pet.composerMenuTitle': 'Pupile',
  'pet.composerMenuHint': 'wskazówka: wpisz /pet, aby przełączyć',
  'pet.composerOpenSettings': 'Zarządzaj zwierzętami',
  'pet.welcomeTeaserTitle': 'Adoptuj pupila',
  'pet.welcomeTeaserBody': 'Mały towarzysz unoszący się nad workspace.',
  'pet.welcomeTeaserCta': 'Wybierz',
  'pet.imageUpload': 'Wgraj sprite',
  'pet.imageReplace': 'Zmień sprite',
  'pet.imageRemove': 'Użyj emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF lub SVG. Spritesheet? Wgraj poziomy pasek i ustaw liczbę klatek.',
  'pet.imageHintActive': 'Wyświetlam Twój sprite. Ustaw klatki > 1, aby animować poziomy spritesheet.',
  'pet.fieldFrames': 'Klatki',
  'pet.fieldFramesHint': '1 = statyczny. > 1 = poziomy spritesheet.',
  'pet.fieldFps': 'Szybkość (fps)',
  'pet.fieldFpsHint': 'Jak szybko klatki się zmieniają.',
  'pet.atlasImport': 'Importuj sprite Codex',
  'pet.atlasImportTitle': 'Zaimportuj atlas hatch-pet 8x9 / 192x208 (PNG lub WebP).',
  'pet.atlasPickerTitle': 'Wybierz wiersz animacji',
  'pet.atlasPickerHint': 'Pety Codex mają 9 wierszy animacji. Domyślnie zachowujemy cały atlas, aby pet przełączał wiersze przy hoverze, kierunku przeciągania i dłuższej bezczynności. Możesz też zablokować jeden loop.',
  'pet.atlasCancel': 'Odrzuć atlas',
  'pet.atlasAdopt': 'Zablokuj na tym wierszu',
  'pet.atlasAdoptFull': 'Użyj pełnego atlasu (animowany)',
  'pet.atlasAdoptFullTitle': 'Zachowaj wszystkie wiersze, aby pet reagował na hover, kierunek przeciągania i długą bezczynność.',
  'pet.atlasAdoptRowTitle': 'Wytnij tylko podświetlony wiersz jako pojedynczy zapętlony pasek.',
  'pet.atlasActiveHint': 'Animowany atlas aktywny — pet wybiera wiersz na podstawie Twojej interakcji (hover, przeciąganie, bezczynność).',
  'pet.atlasRow.idle': 'Bezruch',
  'pet.atlasRow.running-right': 'Bieg w prawo',
  'pet.atlasRow.running-left': 'Bieg w lewo',
  'pet.atlasRow.waving': 'Machanie',
  'pet.atlasRow.jumping': 'Skok',
  'pet.atlasRow.failed': 'Porażka',
  'pet.atlasRow.waiting': 'Oczekiwanie',
  'pet.atlasRow.running': 'Bieg',
  'pet.atlasRow.review': 'Przegląd',
  'pet.hatchTitle': 'Wykluj nowego peta z AI',
  'pet.hatchHint': 'Użyj dołączonej skill hatch-pet w czacie, aby wygenerować spritesheet w stylu Codex, a potem zaimportuj go tutaj.',
  'pet.hatchConcept': 'Koncept peta (opcjonalnie)',
  'pet.hatchConceptPlaceholder': 'np.: mały pixel-art shiba w przytulnym sweterku',
  'pet.hatchCopy': 'Kopiuj prompt',
  'pet.hatchCopied': 'Skopiowano!',
  'pet.hatchFoot': 'Gdy skill zapisze peta, wróć tutaj i kliknij „Importuj sprite Codex".',
  'pet.slashPopoverAria': 'Polecenia slash',
  'pet.slashPopoverTitle': 'Polecenia',
  'pet.slashPopoverHint': '↑↓ nawigacja · enter wybierz · esc zamknij',
  'pet.slashPet': 'Przełącz, adoptuj lub otwórz ustawienia peta.',
  'pet.slashPetWake': 'Obudź pływającego peta.',
  'pet.slashPetTuck': 'Schowaj peta na razie.',
  'pet.slashHatch': 'Wygeneruj peta Codex skillem hatch-pet.',
  'pet.slashHatchArg': '<koncept>',
  'pet.slashSearch': 'Szukaj w sieci przez polecenie OD research.',
  'pet.slashSearchArg': '<zapytanie>',
  'pet.codexTitle': 'Niedawno wyklute',
  'pet.codexSubtitle': 'Pety zapakowane przez skill hatch-pet pojawiają się tutaj do adopcji jednym kliknięciem.',
  'pet.codexSubtitleWithDir': 'Skanuję {dir} w poszukiwaniu paczek hatch-pet.',
  'pet.codexEmpty': 'Brak wyklutych petów. Wpisz /hatch w czacie, aby wygenerować.',
  'pet.codexLoading': 'Szukam wyklutych petów…',
  'pet.codexRefresh': 'Odśwież',
  'pet.codexAdopt': 'Adoptuj',
  'pet.codexAdopting': 'Adoptuję…',
  'pet.communitySync': 'Pobierz zwierzaki społeczności',
  'pet.communitySyncing': 'Pobieranie…',
  'pet.communitySyncTitle': 'Zsynchronizuj najnowsze zwierzaki z Codex Pet Share + j20 Hatchery do ~/.codex/pets/.',
  'pet.communitySyncDone': 'Zsynchronizowano {wrote} nowych zwierzaków (łącznie {total}).',
  'pet.communitySyncFailed': 'Błąd synchronizacji: {error}',
  'pet.codexBundled': 'W zestawie',
  'pet.codexBundledTitle': 'Dostarczany z Open Design — bez pobierania.',

  'settings.notifications': 'Powiadomienia',
  'settings.notificationsHint': 'Dźwięk i powiadomienie pulpitu po zakończeniu zadania',
  'settings.notifyCompletionSound': 'Dźwięk zakończenia',
  'settings.notifyCompletionSoundHint': 'Odtwarzane po zakończeniu tury. Domyślnie wyłączone.',
  'settings.notifySuccessSound': 'Dźwięk sukcesu',
  'settings.notifyFailureSound': 'Dźwięk błędu',
  'settings.notifyDesktop': 'Powiadomienie pulpitu',
  'settings.notifyDesktopHint': 'Wysyłane, gdy okno nie jest aktywne.',
  'settings.notifyDesktopBlocked': 'Zablokowane przez przeglądarkę. Włącz je w ustawieniach witryny.',
  'settings.notifyDesktopUnsupported': 'Powiadomienia pulpitu są niedostępne w tym środowisku.',
  'settings.notifyTest': 'Wyślij test',
  'settings.notifyTestSent': 'Powiadomienie testowe wysłane. Jeśli baner się nie pojawi, sprawdź ustawienia powiadomień przeglądarki i systemu.',
  'settings.notifyTestFailed': 'Wywołanie powiadomienia nie powiodło się. Sprawdź ustawienia powiadomień przeglądarki i systemu.',
  'settings.notifySoundDing': 'Dzyń',
  'settings.notifySoundChime': 'Dzwonek',
  'settings.notifySoundTwoToneUp': 'Dwuton rosnący',
  'settings.notifySoundPluck': 'Szarpnięcie',
  'settings.notifySoundBuzz': 'Brzęczenie',
  'settings.notifySoundTwoToneDown': 'Dwuton malejący',
  'settings.notifySoundThud': 'Łomot',
  'settings.skills': 'Umiejętności',
  'settings.skillsHint': 'Umiejętności funkcyjne, które agent może wywołać w trakcie zadania',
  'settings.skillsNew': 'Nowa umiejętność',
  'settings.skillsEmpty': 'Wybierz umiejętność po lewej lub utwórz nową.',
  'settings.skillsEdit': 'Edytuj',
  'settings.skillsDelete': 'Usuń',
  'settings.skillsDeleteConfirm': 'Potwierdź usunięcie',
  'settings.skillsName': 'Nazwa',
  'settings.skillsTriggers': 'Wyzwalacze (rozdzielone przecinkami lub nowymi liniami)',
  'settings.skillsDescription': 'Opis',
  'settings.skillsBody': 'Treść SKILL.md',
  'settings.skillsCreate': 'Utwórz',
  'settings.skillsSave': 'Zapisz',
  'settings.skillsSaving': 'Zapisywanie…',
  'settings.skillsFiles': 'Pliki',
    'settings.skillsNoFiles': 'Brak plików w tym folderze umiejętności.',
  'settings.skillsNameRequired': 'Nazwa umiejętności jest wymagana.',
  'settings.skillsBodyRequired': 'Treść umiejętności jest wymagana.',
  'settings.designSystems': 'Systemy projektowe',
  'settings.designSystemsHint': 'Przeglądaj i przełączaj dostępne systemy projektowe',
  'settings.designSystemsInstalled': 'Zainstalowane',
  'settings.designSystemsAdd': 'Dodaj system projektowy',
  'settings.designSystemsHiddenCount': '{count} ukryte w galerii głównej',
  'settings.designSystemsShowAll': 'Pokaż wszystkie',
  'settings.designSystemsShowHidden': 'Pokaż ukryte',
  'settings.designSystemsSource': 'Źródło',
  'settings.designSystemsSourceLocal': 'Lokalnie',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsStructure': 'Struktura',
  'settings.designSystemsModeHybrid': 'Hybrydowa',
  'settings.designSystemsModeNormalized': 'Znormalizowana',
  'settings.designSystemsModeVerbatim': 'Bez zmian',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': 'Kolor',
  'settings.designSystemsCraftAccessibility': 'Dostępność',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'Ścieżka projektu',
  'settings.designSystemsImportGithub': 'Importuj z GitHub',
  'settings.designSystemsImportProject': 'Importuj z projektu',
  'settings.designSystemsImportedStatus': 'Zaimportowano {title}',
  'settings.designSystemsViewImported': 'Pokaż zaimportowany system projektowy',
  'settings.designSystemsCategory': 'Kategoria',
  'settings.designSystemsAllCategories': 'Wszystkie kategorie',
  'settings.designSystemsShowInHomeGallery': 'Pokaż w galerii głównej',
  'settings.librarySkills': 'Umiejętności',
  'settings.libraryDesignSystems': 'Systemy projektowe',
  'settings.librarySearch': 'Szukaj...',
  'settings.libraryAll': 'Wszystkie',
  'settings.libraryPreview': 'Podgląd',
  'settings.libraryPreviewClose': 'Zamknij',
  'settings.libraryLoading': 'Ładowanie...',
  'settings.libraryNoResults': 'Brak elementów pasujących do wyszukiwania.',
  'settings.libraryEnabled': 'Włączone',
  'settings.libraryDisabled': 'Wyłączone',
  'settings.connectorsNavHint': 'Połączenia z systemami zewnętrznymi',
  'settings.connectorsHint': 'Zarządzaj ustawieniami konektorów i dostawców narzędzi dla tego urządzenia.',
  'settings.connectorsComposioApiKey': 'Klucz API Composio',
  'settings.connectorsSavedTitle': 'Zapisano w lokalnym daemon',
  'settings.connectorsSavedWithTail': 'Zapisano · ••••{tail}',
  'settings.connectorsSaved': 'Zapisano',
  'settings.connectorsGetApiKey': 'Pobierz klucz API',
  'settings.connectorsReplaceKeyPlaceholder': 'Wklej nowy klucz, aby zastąpić zapisany',
  'settings.connectorsApiKeyPlaceholder': 'Wklej klucz API Composio',
  'settings.connectorsClear': 'Wyczyść',
  'settings.connectorsClearConfirmTitle': 'Wyczyścić zapisany klucz API Composio?',
  'settings.connectorsClearConfirmBody': 'Usunięcie klucza odłącza wszystkie konektory Composio powiązane z tym workspace. Połączone konta, zgody OAuth oraz dostęp do narzędzi zostaną usunięte.',
  'settings.connectorsClearConfirmContinue': 'Kontynuuj',
  'settings.connectorsClearFinalTitle': 'To odłączy wszystkie konektory',
  'settings.connectorsClearFinalBody': 'Tej operacji nie da się cofnąć. Po wklejeniu nowego klucza każdą integrację trzeba podłączyć od nowa.',
  'settings.connectorsClearFinalConfirm': 'Usuń klucz i odłącz',
  'settings.connectorsClearArming': 'Chwilka\u2026',
  'settings.connectorsClearCancel': 'Anuluj',
  'settings.connectorsSaveKey': "Zapisz klucz",
  'settings.connectorsSaveKeyTitle': "Wyślij ten klucz do lokalnego demona",
  'settings.connectorsKeySaving': "Zapisywanie…",
  'settings.connectorsKeySaved': "Zapisano ✓",
  'settings.connectorsKeyError': "Nie udało się zapisać klucza. Sprawdź, czy lokalny demon działa, i spróbuj ponownie.",
  'settings.connectorsHelpSaved': 'Twój klucz odblokowuje katalog poniżej i pozostaje w lokalnym daemon. Wklej nowy klucz, aby go zastąpić, albo wyczyść, aby usunąć.',
  'settings.connectorsHelpUnsaved': "Niezapisane zmiany — kliknij Zapisz klucz, aby zachować te dane w lokalnym demonie i odblokować katalog poniżej.",
  'settings.connectorsHelpEmpty': 'Dodaj klucz, aby odblokować katalog poniżej. Klucze są przechowywane lokalnie w daemon i nigdy nie są wysyłane przez zmienne środowiskowe.',
  'settings.connectorsLoadingSavedKey': 'Sprawdzanie zapisanego klucza w lokalnym daemon…',
  'settings.autosaveSaving': "Zapisywanie…",
  'settings.autosaveSaved': "Wszystkie zmiany zapisane",
  'settings.autosaveError': "Nie udało się zapisać zmian. Lokalny demon może być offline.",
  'settings.libraryToggleLabel': 'Przełącz',
  // Memory (auto-extracted personalization saved as on-disk markdown)
  'settings.memory': 'Memory',
  'settings.memoryHint': 'Personal facts auto-extracted from chats',
  'settings.memoryDescription': 'Auto-extracted facts about you and your preferences. Saved as Markdown files and folded into every chat.',
  'settings.memoryEnabled': 'Enabled',
  'settings.memoryDisabled': 'Disabled',
  'settings.memoryEnableLabel': 'Enable memory injection',
  'settings.memoryDisabledBanner': 'Memory is currently OFF. Existing facts are preserved on disk but will not be folded into new chats and new turns will not extract anything new.',
  'settings.memoryNew': 'New memory',
  'settings.memoryEdit': 'Edit',
  'settings.memoryDelete': 'Delete',
  'settings.memoryPreview': 'Preview',
  'settings.memoryEmpty': 'No memory yet.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'I prefer dark mode',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'One-line description',
  'settings.memoryBody': 'Memory body (Markdown supported)',
  'settings.memoryBodyHint': 'Lead with the rule itself; add Why and How to apply lines.',
  'settings.memoryStartersLabel': 'Need a starting point? Click to fill the form:',
  'settings.memoryStarterUserName': 'My role',
  'settings.memoryStarterUserDesc': 'I am a frontend engineer working on a SaaS design tool',
  'settings.memoryStarterUserBody': '- Role: senior frontend engineer\n- Stack: React, TypeScript, Vite\n- Domain: design / collaboration tools\n- Timezone: GMT+8 (Asia/Shanghai)\n\nWhen to apply: any chat — frame examples around web frontend.',
  'settings.memoryStarterFeedbackName': 'UI preferences',
  'settings.memoryStarterFeedbackDesc': 'Dark mode, large body text, low information density',
  'settings.memoryStarterFeedbackBody': '- Theme: dark by default\n- Body text: ≥ 18px\n- Information density: prefer whitespace, fewer items per screen\n\nWhy: less eye strain during long sessions.\nWhen to apply: whenever you generate UI, web pages, or slides.',
  'settings.memoryStarterProjectName': 'Current project',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — chat-driven design editor',
  'settings.memoryStarterProjectBody': '- Goal: ship the chat-driven editor this quarter\n- Priorities: streaming render, local multimodal, offline-first\n- Stack: Next.js 16, Express daemon, SQLite\n\nWhen to apply: in any conversation about this project.',
  'settings.memorySaveHint': 'Not auto-saved — click Create / Save to apply.',
  'settings.memoryIndexSaveHint': 'Edits to the index are not auto-saved — click Save index to apply.',
  'settings.memoryIndexUnsaved': 'Unsaved changes',
  'settings.memoryFlashCreated': '✓ Memory created',
  'settings.memoryFlashSaved': '✓ Memory saved',
  'settings.memoryFlashDeleted': '✓ Memory deleted',
  'settings.memoryFlashIndexSaved': '✓ Index saved',
  'settings.memoryFlashPathCopied': '✓ Ścieżka skopiowana',
  'settings.memoryNameLabel': 'Title',
  'settings.memoryTypeLabel': 'Type',
  'settings.memoryDescLabel': 'Description',
  'settings.memoryBodyLabel': 'Content',
  'settings.memoryTypeUser': 'User',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Project',
  'settings.memoryTypeReference': 'Reference',
  'settings.memoryIndex': 'MEMORY.md (index)',
  'settings.memoryIndexSave': 'Save index',
  'settings.memoryIndexReset': 'Reset',
  'settings.memoryToastChanged': 'Memory updated',
  'settings.memoryToastClickHint': 'Zobacz',
  'settings.memoryAll': 'All',
  'settings.memoryExtractions': 'Extraction history',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'No extractions yet. The next chat turn will populate this list.',
  'settings.memoryExtractionsRefresh': 'Refresh',
  'settings.memoryExtractionsRefreshing': 'Refreshing…',
  'settings.memoryExtractionPhaseRunning': 'Running…',
  'settings.memoryExtractionPhaseSuccess': 'Success',
  'settings.memoryExtractionPhaseSkipped': 'Skipped',
  'settings.memoryExtractionPhaseFailed': 'Failed',
  'settings.memoryExtractionSkipNoProvider': 'No API key configured for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'Memory is disabled.',
  'settings.memoryExtractionSkipEmpty': 'Empty user message — nothing to extract.',
  'settings.memoryExtractionSkipNoMatch': 'No regex pattern matched this turn.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'media settings',
  'settings.memoryExtractionProposed': 'proposed',
  'settings.memoryExtractionWritten': 'written',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryNoProviderBannerTitle': 'LLM memory extraction is not running',
  'settings.memoryNoProviderBannerBody': 'No API key found for the memory extractor. Add an OpenAI key under Media providers, or set ANTHROPIC_API_KEY / OPENAI_API_KEY in the environment, to enable LLM-driven extraction. Heuristic regex extraction is still active.',
  'settings.memoryExtractionProviderOverride': 'memory settings',
  'settings.memoryExtractionDelete': 'Delete',
  'settings.memoryExtractionsClear': 'Clear',
  'settings.memoryExtractionsClearTitle': 'Clear all extraction history',
  'settings.libraryInstall': 'Zainstaluj',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Ścieżka lokalna',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Zainstaluj',
  'settings.libraryUninstall': 'Odinstaluj',
  'settings.libraryBuiltIn': 'Wbudowany',
  'settings.libraryInstalled': 'Zainstalowany',
  'notify.successTitle': 'Zadanie ukończone',
  'notify.failureTitle': 'Zadanie nieudane',
  'notify.successBody': 'Tura zakończona.',
  'notify.failureBody': 'Zadanie zakończyło się błędem.',
  'updater.available': 'Aktualizacja dostępna',
  'updater.availableBody': 'Open Design {version} jest dostępny. Zostanie pobrany przed otwarciem instalatora.',
  'updater.checking': 'Sprawdzanie aktualizacji',
  'updater.download': 'Pobierz aktualizację',
  'updater.downloading': 'Pobieranie aktualizacji',
  'updater.downloadingPercent': 'Pobieranie aktualizacji {percent}%',
  'updater.done': 'Gotowe',
  'updater.failed': 'Aktualizacja nie powiodła się',
  'updater.installerOpenBody': 'Instalator jest otwarty. Open Design zamyka się, aby można było dokończyć aktualizację.',
  'updater.installerOpened': 'Instalator otwarty',
  'updater.later': 'Później',
  'updater.openFailedFallback': 'Nie można otworzyć instalatora.',
  'updater.openInstaller': 'Zainstaluj aktualizację',
  'updater.opening': 'Otwieranie instalatora...',
  'updater.quitButton': 'Zamknij Open Design',
  'updater.quitFailedBody': 'Instalator jest otwarty, ale nie można zamknąć Open Design. Zamknij Open Design przed zastąpieniem aplikacji.',
  'updater.quitFailedTitle': 'Nie można zamknąć',
  'updater.quitting': 'Zamykanie...',
  'updater.ready': 'Aktualizacja gotowa',
  'updater.readyGeneric': 'Nowa wersja jest gotowa. Open Design zamknie się i otworzy instalator.',
  'updater.readyVersion': 'Open Design {version} jest gotowy. Open Design zamknie się i otworzy instalator.',
  'updater.upToDate': 'Masz już najnowszą wersję.',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Automatyzacja',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Dzienne podsumowanie konektorów',
  'settings.orbit.lede': 'Zbieraj aktywność konektorów według harmonogramu i publikuj wynik jako odświeżalny live artifact.',
  'settings.orbit.statusOnTitle': 'Codzienne uruchomienia według harmonogramu są włączone',
  'settings.orbit.statusOffTitle': 'Codzienne uruchomienia według harmonogramu są wyłączone',
  'settings.orbit.statusActive': 'Aktywne',
  'settings.orbit.statusOff': 'Wyłączone',
  'settings.orbit.runTitle': 'Uruchom Orbit i otwórz rozmowę na żywo',
  'settings.orbit.running': 'Uruchamianie…',
  'settings.orbit.runOpen': 'Uruchom teraz',
  'settings.orbit.dailySummaryTitle': 'Podsumowanie dzienne',
  'settings.orbit.dailySummarySub': 'Uruchamia się raz dziennie o zaplanowanej lokalnej godzinie.',
  'settings.orbit.on': 'Włączone',
  'settings.orbit.off': 'Wyłączone',
  'settings.orbit.runTimeTitle': 'Czas uruchomienia',
  'settings.orbit.runTimeSub': 'Domyślnie 08:00. Zapisz, aby zastosować harmonogram daemon.',
  'settings.orbit.runTimeAria': 'Codzienny czas uruchomienia Orbit',
  'settings.orbit.nextRun': 'Następne uruchomienie',
  'settings.orbit.nextRunScheduledAfterSave': 'Zaplanowane po zapisie',
  'settings.orbit.schedule': 'Harmonogram',
  'settings.orbit.pausedManualOnly': 'Wstrzymane — tylko uruchomienia ręczne',
  'settings.orbit.templateTitle': 'Szablon prompt',
  'settings.orbit.templateMissing': 'Szablon {id} nie jest zainstalowany.',
  'settings.orbit.templateMissingOption': '{id} (brak)',
  'settings.orbit.templateMissingInstall': 'Zainstaluj skill Orbit, aby sterować prompt.',
  'settings.orbit.templateMissingPickAnother': 'Wybierz inny szablon z listy.',
  'settings.orbit.templateResetTitle': 'Resetuj do {id}',
  'settings.orbit.templateReset': 'Resetuj',
  'settings.orbit.templateHelp': 'Steruj Orbit za pomocą skill — przykładowy prompt wybranego szablonu jest wstrzykiwany do każdego uruchomienia Orbit, aby podsumowania miały kształt tego szablonu.',
  'settings.orbit.templateAria': 'Szablon prompt Orbit',
  'settings.orbit.templatesLoading': 'Ładowanie szablonów…',
  'settings.orbit.templatesOptgroup': 'Szablony skills Orbit',
  'settings.orbit.lastRun': 'Ostatnie uruchomienie',
  'settings.orbit.triggerManual': 'Ręczne',
  'settings.orbit.triggerScheduled': 'Zaplanowane',
  'settings.orbit.meterAria': '{succeeded} udanych, {skipped} pominiętych, {failed} nieudanych z {checked} sprawdzonych',
  'settings.orbit.countChecked': 'Sprawdzone',
  'settings.orbit.countSucceeded': 'Udane',
  'settings.orbit.countSkipped': 'Pominięte',
  'settings.orbit.countFailed': 'Nieudane',
  'settings.orbit.runError': 'Nie można uruchomić Orbit. Upewnij się, że lokalny daemon działa, a konektory są skonfigurowane.',
  'settings.orbit.gateAriaLabel': "Do działania Orbit wymagane są łączniki",
  'settings.orbit.gateEyebrow': "Wymagana konfiguracja",
  'settings.orbit.gateTitle': "Połącz narzędzie, aby uruchomić Orbit",
  'settings.orbit.gateBody': "Orbit podsumowuje aktywność Twoich łączników. Nic jeszcze nie zostało podłączone — dodaj co najmniej jedną integrację, aby Orbit miał o czym raportować.",
  'settings.orbit.gateBodyNoKey': "Orbit podsumowuje aktywność Twoich łączników, a łączniki działają przez Composio. Dodaj klucz API Composio w sekcji Łączniki, aby odblokować katalog i wybrać pierwszą integrację.",
  'settings.orbit.gateAction': "Otwórz Łączniki",
  'settings.orbit.gateActionNoKey': "Skonfiguruj Composio",
  'settings.orbit.gateLoading': "Sprawdzanie łączników…",
  'settings.orbit.controlsLockedBadge': "Zablokowane",
  'settings.orbit.controlsLockedHint': "Podłącz narzędzie, aby odblokować harmonogram i szablon Orbit.",
  'settings.orbit.artifactKickerLive': 'live artifact',
  'settings.orbit.artifactKickerLegacy': 'Starsze podsumowanie',
  'settings.orbit.artifactTitle': 'Dzienne podsumowanie aktywności Orbit',
  'settings.orbit.artifactMetaLive': 'Odświeżalny artefakt HTML wygenerowany z aktywności konektorów.',
  'settings.orbit.artifactMetaLegacy': 'Wygenerowano przed włączeniem obsługi live artifact — uruchom Orbit ponownie, aby opublikować jeden.',
  'settings.orbit.copyMarkdownTitle': 'Kopiuj podsumowanie Markdown do schowka',
  'settings.orbit.copied': 'Skopiowano',
  'settings.orbit.copy': 'Kopiuj',
  'settings.orbit.openArtifact': 'Otwórz artefakt',
  'settings.orbit.sourceMarkdown': 'Źródłowy Markdown',
  'liveArtifact.viewer.tabPreview': 'Podgląd',
  'liveArtifact.viewer.tabCode': 'Kod',
  'liveArtifact.viewer.tabData': 'Dane',
  'liveArtifact.viewer.tabRefreshHistory': 'Historia odświeżeń',
  'liveArtifact.viewer.dataEmpty': 'Brak dostępnego cache data.json.',
  'liveArtifact.viewer.code.templateHeading': 'HTML szablonu',
  'liveArtifact.viewer.code.renderedHeading': 'Wyrenderowany HTML',
  'liveArtifact.viewer.code.templateHelp': 'Edytowalny szablon używany z data.json do wygenerowania podglądu.',
  'liveArtifact.viewer.code.renderedHelp': 'Wygenerowany index.html aktualnie ładowany przez podgląd.',
  'liveArtifact.viewer.code.variantAria': 'Wariant kodu',
  'liveArtifact.viewer.code.variantTemplate': 'Szablon',
  'liveArtifact.viewer.code.variantRendered': 'Wyrenderowany',
  'liveArtifact.viewer.code.loading': 'Ładowanie kodu…',
  'liveArtifact.viewer.code.unavailable': 'Kod nie jest jeszcze dostępny.',
  'liveArtifact.viewer.code.empty': 'Ten plik kodu jest pusty.',
  // Diagnostics export
  'diagnostics.exportTitle': 'Eksportuj diagnostykę',
  'diagnostics.exportButton': 'Eksportuj diagnostykę',
  'diagnostics.exportHint': 'Pakuje ostatnie logi aplikacji i informacje o urządzeniu w archiwum zip do wysłania zespołowi.',
  'diagnostics.exporting': 'Eksportowanie…',
  'diagnostics.exportSuccess': 'Diagnostyka zapisana w {path}',
  'diagnostics.exportFailed': 'Nie udało się wyeksportować diagnostyki: {message}',
};
